import React from 'react'
import {
    TrainingsOverviewMetaProps,
    AllocationsOverviewMetaProps,
    AdminHubMetaProps,
    AdminSettingsMetaProps,
    AdminTrainingsMetaProps,
    AreaFormModalMetaProps,
    AssignTrainingFormModalMetaProps,
    ConfirmationModalMetaProps,
    DeleteAreaMetaProps,
    DeleteDutyMetaProps,
    DeleteEventMetaProps,
    DeletePreferenceMetaProps,
    DeleteFlagMetaProps,
    DeleteShiftMetaProps,
    DocumentViewerMetaProps,
    DuplicateAreaModalMetaProps,
    DuplicateEventModalMetaProps,
    DutyCardMetaProps,
    DutyFormModalMetaProps,
    DutyMetaProps,
    EventCardMetaProps,
    EventDetailMetaProps,
    EventFormModalMetaProps,
    EventsMetaProps,
    FooterMetaProps,
    HeaderMetaProps,
    HomeMetaProps,
    LoadingSpinnerMetaProps,
    LoginMetaProps,
    Nav,
    PreferenceCardMetaProps,
    PreferenceFormModalMetaProps,
    PreferenceMetaProps,
    FlagCardMetaProps,
    FlagFormModalMetaProps,
    FlagMetaProps,
    FlagCategoryFormModalMetaProps,
    UpdateFlagCategoryFormMetaProps,
    DeleteFlagCategoryMetaProps,
    ShiftFormModalMetaProps,
    DuplicateShiftModalMetaProps,
    CopyShiftAllocationsModalMetaProps,
    CompletionQuestionsModalMetaProps,
    TermsAndConditionsMetaProps,
    TrainingFormModalMetaProps,
    TrainingListMetaProps,
    TrainingModulePageMetaProps,
    UnsupportedModuleViewerMetaProps,
    UpdateAreaFormMetaProps,
    UpdateDutyFormMetaProps,
    UpdateEventFormMetaProps,
    UpdatePreferenceFormMetaProps,
    UpdateFlagFormMetaProps,
    UpdateShiftFormMetaProps,
    UpdateTrainingFormMetaProps,
    VideoPlayerMetaProps,
    VolunteerCardMetaProps,
    VolunteerFormModalMetaProps,
    VolunteerProfileMetaProps,
    VolunteersMetaProps,
    VolunteerTrainingPageDetailsMetaProps,
    VolunteerTrainingPageMetaProps,
    VolunteerPoliciesMetaProps,
    TrainingModuleMetaProps,
    AnnouncementMetaProps,
    AnnouncementFormModalMetaProps,
    AnnouncementViewModalMetaProps,
    BulkTrainingAssignmentFormMetaProps,
    ShiftAssignmentFormMetaProps,
    VolunteerFiltersWithConflictProps,
    UserFormModalMetaProps,
    UpdateUserFormMetaProps,
    DeleteUserMetaProps,
    LeadAssignModalPropsMeta,
    AccessColorMetaProps,
    AccessColorFormModalMetaProps,
    CoreTeamMetaProps,
    CoreTeamStatsMetaProps,
    CoreTeamTableMetaProps,
    RejectedCoreTeamTableMetaProps,
    CoreTeamFormModalMetaProps,
    CoreTeamAddModalMetaProps,
    Role,
    TrainingSequenceEditMetaProps,
    MaxChartSize,
    ManagementAnalyticsMetaProps,
    AnalyticsTab,
    VolunteerOverviewMetaProps,
    DashboardMetaProps,
    InternationalRegisterationsMetaProps,
    CoreStreamOverviewMetaProps,
    VolunteerStatsTableOverviewMetaProps,
    DidarAcknowledgementOverviewMetaProps,
    EmailCampaignsMetaProps,
    EmailCampaignFormMetaProps,
    EmailCampaignPreviewMetaProps,
    ShiftMoveModalMetaProps,
    VolunteerUploadDocumentFormMetaProps,
    AllocationStatusPageMetaProps,
    CheckInPageMetaProps,
    DutyStatusOverviewMetaProps,
    QuickAllocateModalMetaProps,
    LiveOperationsMetaProps,
    LiveStatusTab,
    LoginFormMetaProps,
    ForgetPasswordMetaProps,
    ResetPasswordMetaProps,
    SignupMetaProps,
    VerifyEmailMetaProps,
    HouseholdSelectionMetaProps,
    CheckInLoginFormMetaProps,
    PublicFormFillMetaProps,
    PublicFormsMetaProps,
    GuidelineFormModalMetaProps,
    AdminGuidelinesMetaProps,
    VolunteerGuidelinesMetaProps,
    GuidelineDetailsMetaProps,
    DirectorVolunteerMetaProps
} from './types'
import { Link } from 'react-router-dom'
import { ExternalLinkIcon } from '../icons'

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api'
const IIUK_BASE_URL = process.env.REACT_APP_IIUK_BASE_URL || 'https://iiuk.org'

export const ROLE_MAP: { [key in Role]: string } = {
    volunteer: 'Freiwilliger',
    lead: 'Leiter',
    super_lead: 'Hauptleiter',
    allocating_lead: 'Zuteilungsleiter',
    reallocation_manager: 'Umverteilungsmanager',
    core_team: 'Kernteam',
    core_team_approver: 'Kernteam-Genehmiger',
    hr_team_member: 'HR-Teammitglied',
    hr_deputy: 'HR-Stellvertreter',
    hr_admin: 'HR-Administrator',
    admin: 'Administrator',
    checkin_volunteer: 'Check-in-Freiwilliger',
    checkin_admin: 'Check-in-Administrator',
    lead_with_stats: 'Leiter mit Statistiken',
    jv_exec: 'JV Exec',
    jv_lead: 'JV Lead',
    iv_director: 'IV Director',
    iv_deputy_director: 'IV Deputy Director'
}

const HeaderNav: Nav = {
    home: { title: 'Startseite', path: `/` },
    profile: { title: 'Profil', path: `/profile` },
    trainings: { title: 'Meine Schulungen', path: '/volunteer/training' },
    policies: { title: 'Richtlinien', path: '/volunteer/policies' },
    events: { title: 'Veranstaltungen', path: '/events', show: (user) => user.permissions?.includes('view_events') && user.permissions.includes('view_admin_hub') },
    check_in: { title: 'Check-in', path: '/admin/check-in', show: (user) => user.permissions?.includes('manage_check_ins') },
    coreTeam: { title: 'Kernteam', path: '/core-team', show: (user) => user.permissions?.includes('view_core_team') },
    admin: { title: 'Admin', path: `/admin`, show: (user) => user.permissions?.includes('view_admin_hub') },
    faq: { title: 'FAQ', path: 'https://iv.iiuk.org/vms-faq/' },
}

export const HeaderMeta: HeaderMetaProps = {
    title: 'Freiwilligen-Management-System',
    themeToggleLightLabel: 'Zum hellen Modus wechseln',
    themeToggleDarkLabel: 'Zum dunklen Modus wechseln',
    themeToggleSystemLabel: 'Systemdesign verwenden',
    languageSelectorLabel: 'Sprache auswählen',
    logout: 'Abmelden',
    loggingOutText: 'Abmelden...',
    nav: HeaderNav
}

export const FooterMeta: FooterMetaProps = {
    nav: {
        termsAndCondition: 'Nutzungsbedingungen',
        privacyNotice: 'Datenschutzerklärung'
    },
    version: 2026,
    copyRight: 'Alle Rechte vorbehalten'
}

export const TermsAndConditionsMeta: TermsAndConditionsMetaProps = {
    title: 'Einwilligung in Freiwilligendaten & Datenschutzerklärung',
    content: `Mit Ihrer Registrierung erkennen Sie an und stimmen zu, dass das Ismaili Volunteers VMS Ihre personenbezogenen Daten sammelt und verwendet, um die Freiwilligenarbeit zu verwalten, einschließlich der Zuweisung geeigneter Aufgaben und der Verwaltung Ihrer Schulungen.

**Was wir speichern**: Wir speichern nur relevante Informationen über Freiwillige, die den vollständigen Namen, die E-Mail-Adresse, die Handynummer, die Altersgruppe, die Aufgabenpräferenzen und die Fähigkeiten umfassen können. Wenn Sie über eine Überprüfung durch den Disclosure & Barring Service verfügen, erfassen wir möglicherweise auch diese Informationen.

**Weitergabe Ihrer Kontaktdaten(für Freiwilligenzwecke)**: Zur Unterstützung der Freiwilligenaktivitäten können Ihre Kontaktdaten an die zuständigen Teamleiter innerhalb unseres Ausschusses oder(gegebenenfalls) an relevante Ansprechpartner der Institution weitergegeben werden, damit diese Sie bezüglich Freiwilligenaufgaben, Zeitplänen, Aktualisierungen und betrieblichen Anforderungen kontaktieren können.

**Schulungs- und Aufgabenprotokolle**: Sie verstehen, dass Ihre Schulungsaktivitäten(z.B. Abschluss von Lern-/Schulungsvideos) und Ihre Aufgabenteilnahme/ - zuweisungen für betriebliche, sicherheitsrelevante und Compliance-Zwecke in Ihrem Freiwilligenprofil aufgezeichnet und protokolliert werden können.

**Datenschutz**: Wir werden Ihre Daten in Übereinstimmung mit den geltenden Regeln und Vorschriften verarbeiten und speichern und dabei angemessene technische und organisatorische Sicherheitsmaßnahmen anwenden.Daten werden nur so lange aufbewahrt, wie es für die Verwaltung der Freiwilligenarbeit und für rechtliche/Compliance - Anforderungen erforderlich ist.\n\nDurch das Akzeptieren bestätige ich, dass ich das Obige gelesen habe und dem zustimme, und dass ich in die Verarbeitung meiner Daten zur Freiwilligenverwaltung wie oben beschrieben einwillige.`,
    agreeButton: 'Ich stimme zu',
    disagreeButton: 'Ich lehne ab'
}


export const AdminHubMeta: AdminHubMetaProps = {
    title: 'Admin-Hub',
    description: 'Greifen Sie auf alle Verwaltungstools und Managementfunktionen zu',
    dashboardTitle: 'Dashboard',
    dashboardDescription: 'Übersicht der Benutzer und Freiwilligen',
    eventsTitle: 'Veranstaltungen',
    eventsDescription: 'Veranstaltungen, Bereiche und Schichten erstellen und verwalten',
    volunteersTitle: 'Freiwillige',
    volunteersDescription: 'Freiwilligenprofile und Zuweisungen verwalten',
    trainingsTitle: 'Schulungen',
    trainingsDescription: 'Schulungsinhalte und -module erstellen und verwalten',
    dutiesTitle: 'Aufgaben',
    dutiesDescription: 'Aufgabentypen für Schichten definieren und verwalten',
    preferencesTitle: 'Präferenzen',
    preferencesDescription: 'Präferenzen und Verfügbarkeit von Freiwilligen verwalten',
    flagsTitle: 'Markierungen',
    flagsDescription: 'Markierungen und Attribute von Freiwilligen verwalten',
    settingsTitle: 'Systemeinstellungen',
    settingsDescription: 'Systemweite Einstellungen konfigurieren und Massenaktionen durchführen',
    announcementsTitle: 'Ankündigungen',
    announcementsDescription: 'Ankündigungen posten, um alle Freiwilligen auf dem Laufenden zu halten',
    userTitle: 'Benutzerverwaltung',
    userDescription: 'Benutzer und Rollen mit Zugriffskontrolle verwalten',
    accessColorTitle: 'Zugriffsfarben',
    accessColorDescription: 'Zugriffsfarben verwalten, um den Veranstaltungszugang von Freiwilligen zu kontrollieren.',
    emailCampaignsTitle: 'E-Mail-Kampagnen',
    emailCampaignsDescription: 'Massen-E-Mails an Freiwillige erstellen und senden',
    formsTitle: 'Forms',
    formsDescription: 'Create public forms and review submitted responses',
    miTitle: 'Statistiken',
    miDescription: 'Zusammenfassende Einblicke und Analysen',
    internationalRegisterationTitle: 'Nicht-IIUK-Registrierungen',
    internationalRegisternationDescription: 'Registrierungen von Nicht-IIUK-Freiwilligen verwalten.',
    allocationStatusTitle: 'Aufgabenannahme',
    allocationStatusDescription: 'Annahme-/Ablehnungsstatus der Aufgaben durch Freiwillige einsehen und verwalten',
    checkInTitle: 'Check-in',
    checkInDescription: 'Ausweise scannen, um Freiwillige für ihre Aufgaben einzuchecken',
    eventDayTitle: 'Live-Event-Betrieb',
    eventDayDescription: 'Freiwilligenanwesenheit, Schichtabdeckung und kritische Betriebskennzahlen in Echtzeit überwachen',
    userLogTitle: "Benutzerprotokoll",
    userLogDescription: "Benutzeraktivitäten überwachen",
    guidelineTitle: "Richtlinien",
    guidelineDescription: "Richtlinieninhalte erstellen und verwalten",
    JvTitle: "Junior-Freiwilligen-Punkte",
    JVDescription: "Punkte der Junior-Freiwilligen verwalten",
    directorVolunteerTitle: "Freiwillige deiner Jamat Khana",
    directorVolunteerDescription: "Alle Freiwilligen deiner Jamat Khana anzeigen."
}

export const PublicFormsMeta: PublicFormsMetaProps = {
    title: 'Forms',
    description: 'Create public forms and review responses submitted through shared links',
    backButton: 'Back to Admin Hub',
    createButton: 'Create Form',
    errorTitle: 'Something went wrong',
    noFormsMessage: 'No forms have been created yet.',
    publicUrlLabel: 'Public URL',
    copyLinkButton: 'Copy Link',
    copiedText: 'Copied',
    editButton: 'Edit',
    deleteButton: 'Delete',
    viewResultsButton: 'View Results',
    hideResultsButton: 'Hide Results',
    submissionsTitle: 'Responses',
    noSubmissionsMessage: 'No responses have been submitted yet.',
    submittedAtLabel: 'Submitted',
    activeLabel: 'Active',
    inactiveLabel: 'Inactive',
    submissionsCountLabel: 'responses',
    titleLabel: 'Title',
    slugLabel: 'Custom URL',
    overrideUrlLabel: 'Override URL',
    overrideUrlHelpText: 'Optional. Leave this off to generate a random public link automatically. Turn it on to choose a friendly ending for the URL.',
    customUrlPlaceholder: 'volunteer-interest',
    descriptionLabel: 'Description',
    activeFormLabel: 'Make form live and allow submissions',
    fieldsLabel: 'Fields',
    addFieldButton: 'Add Field',
    fieldLabelLabel: 'Field Label',
    fieldTypeLabel: 'Field Type',
    requiredLabel: 'Required',
    optionsLabel: 'Options',
    optionPlaceholder: 'Option text',
    addOptionButton: 'Add Option',
    removeButton: 'Remove',
    saveButton: 'Save Form',
    savingButton: 'Saving...',
    createModalTitle: 'Create Form',
    editModalTitle: 'Edit Form',
    textTypeLabel: 'Single Line Text',
    emailTypeLabel: 'Email Address',
    checkboxTypeLabel: 'Checkbox Group',
    radioTypeLabel: 'Radio Group',
    selectTypeLabel: 'Dropdown Select',
    deleteTitle: 'Delete Form',
    deleteMessage: 'This will permanently delete the form and all submitted responses.',
    matchByLabel: 'Match volunteers by',
    matchedVolunteerColumn: 'Matched Volunteer',
    matchingLabel: 'Matching...',
    noMatchLabel: 'No match',
    selectMatchButton: (count: number) => `Select (${count})`,
    changeMatchButton: 'Change',
    matchModalTitle: 'Select Matched Volunteer',
    matchModalDescription: 'More than one volunteer matched this email address. Select the correct one.',
    matchIdColumn: 'ID',
    matchNameColumn: 'Name',
    matchEmailColumn: 'Email',
    matchSelectButton: 'Select',
    matchCloseButton: 'Close',
    approveAndAllocateButton: 'Approve & Assign',
    allocateModalTitle: 'Approve and Assign Volunteer',
    allocateEventLabel: 'Event',
    allocateAreaLabel: 'Area',
    allocateShiftLabel: 'Shift',
    allocateSelectEventPlaceholder: 'Select an event',
    allocateSelectAreaPlaceholder: 'Select an area',
    allocateNoShiftsMessage: 'No shifts found for this area.',
    approveAndAllocateConfirmButton: 'Approve & Assign',
    approveAndAllocatingButton: 'Approving...',
    approveAndAllocateSuccessMessage: 'Volunteer approved and assigned successfully.',
    allocateCloseButton: 'Close',
    exportLabel: 'Allow Exports',
    exportResultButton: 'Export Submissions',
    showQrCodeButton: 'Show QR Code',
    qrCodeModalTitle: 'Form QR Code',
    qrCodeModalDescription: 'Scan this code or share the link below to open the public form.',
    downloadPngButton: 'Download PNG',
    qrCodeCloseButton: 'Close'
}

export const PublicFormFillMeta: PublicFormFillMetaProps = {
    loadingText: 'Loading form...',
    errorTitle: 'Unable to load form',
    notFoundMessage: 'This form is not available.',
    requiredLabel: 'Required',
    submitButton: 'Submit',
    submittingText: 'Submitting...',
    successTitle: 'Response Submitted',
    successMessage: 'Thank you. Your response has been recorded.',
    selectPlaceholder: 'Select an option'
}

export const AdminSettingsMeta: AdminSettingsMetaProps = {
    title: 'Systemeinstellungen',
    description: 'Systemweite Konfigurationen verwalten und administrative Aktionen durchführen',
    globalSettingsTitle: 'Globale Einstellungen',
    globalSettingsDescription: 'Systemweite Markierungen und Konfigurationsoptionen',
    visitAnnouncedTitle: 'Besuch angekündigt',
    visitAnnouncedDescription: 'Umschalten, ob der Besuch öffentlich angekündigt wurde. Dies beeinflusst, welche Inhalte für Benutzer sichtbar sind.',
    internationalSignupsEnabledTitle: 'Internationale Anmeldungen aktiviert',
    internationalSignupsEnabledDescription: 'Umschalten, ob sich internationale Besucher anmelden dürfen. Dies beeinflusst die Verfügbarkeit von Anmelde- und Registrierungsoptionen für internationale Besucher.',
    showShiftInfoTitle: 'Schichtinformationen anzeigen',
    showShiftInfoDescription: 'Umschalten, ob Schicht-/Aufgabenzuweisungsinformationen auf der Startseite für Freiwillige angezeigt werden.',
    localModeTitle: 'Lokaler Modus',
    localModeDescription: 'Lokale Barcode-Suche beim Check-in aktivieren. Wenn aktiviert, werden Barcodes in der lokalen Datenbank statt in der externen API nachgeschlagen.',
    trainingManagementTitle: 'Schulungsverwaltung',
    trainingManagementDescription: 'Massenaktionen zur Verwaltung von Freiwilligenschulungen',
    assignMandatoryTitle: 'Obligatorische Schulungen zuweisen',
    assignMandatoryDescription: 'Alle obligatorischen Schulungen automatisch den Freiwilligen zuweisen, die diese noch nicht haben',
    assignButton: 'Allen Freiwilligen zuweisen',
    assigningText: 'Wird zugewiesen...',
    profileManagementTitle: 'Profilverwaltung',
    profileManagementDescription: 'Massenaktionen zur Verwaltung von Freiwilligenprofilen',
    clearProfilesTitle: 'Profilaktualisierungen anfordern',
    clearProfilesDescription: 'Alle Profilübermittlungs-Zeitstempel löschen, um von allen Freiwilligen eine Überprüfung und erneute Einreichung ihrer Profile zu verlangen',
    clearProfilesButton: 'Alle Profile anfordern',
    clearingProfilesText: 'Wird gelöscht...'
}

export const HomeMeta: HomeMetaProps = {
    greeting: (userName: string) => `Hallo ${userName}, `,
    motd: 'Willkommen im Ismaili Volunteers VMS Portal. Diese Plattform wurde geschaffen, um unsere Freiwilligen zu unterstützen, indem sie einen gemeinsamen Raum bietet, um auf Schulungsressourcen zuzugreifen, den Lernfortschritt zu verfolgen und Freiwilligenaufgaben auf durchdachte Weise zu koordinieren. Wir schätzen die Zeit, die Sorgfalt und das Engagement, das Sie weiterhin durch Ihre Khidma (Dienst) erbringen.',
    travelInfo: 'Wenn Sie bereits eine Reise planen und sich freiwillig engagieren möchten, registrieren Sie bitte Ihr Interesse. Freiwilligenarbeit basiert auf persönlichen Vereinbarungen, und alle Reise-, Unterkunfts-, Visa- und damit verbundenen Anforderungen müssen eigenständig organisiert werden.',
    visitAnnouncedProfileTitle: 'Als Freiwilliger registrieren (Europa Didar (Berlin))',
    visitAnnouncedProfileMessage: 'Bitte registrieren Sie Ihr Interesse, als Freiwilliger für den kommenden Europa Didar (Berlin) mitzuwirken.',
    visitAnnouncedCompleteButton: 'Registrierung abschließen',
    profileIncompleteWarningTitle: 'Vervollständigen Sie Ihr Profil',
    profileIncompleteWarningMessage: 'Bitte vervollständigen Sie Ihr Profil, um auf alle Funktionen zugreifen zu können.',
    completeProfileButton: 'Profil vervollständigen',
    policyIncompleteWarningTitle: 'Aktion erforderlich: Richtlinien überprüfen',
    policyIncompleteWarningMessage: (count: number) => `Sie haben ${count} ${count !== 1 ? 'Richtlinien' : 'Richtlinie'}, die Ihre Überprüfung und Bestätigung erfordern.`,
    reviewPoliciesButton: 'Richtlinien überprüfen',
    volunteerMessagesTitle: 'Nachrichten für Freiwillige',
    priorityLabel: 'Priorität',
    viewButton: 'Anzeigen',
    previousButton: 'Zurück',
    nextButton: 'Weiter',
    pageLabel: 'Seite',
    assignedTrainingsTitle: 'Zugewiesene Schulungen',
    noIncompleteTrainingsMessage: 'Alle zugewiesenen Schulungen abgeschlossen!',
    incompleteTrainingsMessage: (count: number) => `Sie haben ${count} unvollständige Schulung${count !== 1 ? 'en' : ''}.`,
    viewTrainingsButton: 'Meine Schulungen ansehen',
    assignedShiftsTitle: 'Zugewiesene Aufgaben',
    noAssignedShiftsMessage: 'Ihnen sind derzeit keine Aufgaben zugewiesen.',
    acceptButton: 'Akzeptieren',
    declineButton: 'Ablehnen',
    pendingLabel: 'Ausstehend',
    acceptedLabel: 'Akzeptiert',
    declinedLabel: 'Abgelehnt',
    loadingShiftsText: 'Ihre Schichten werden geladen...',
    shiftTimeLabel: 'Schichtzeit',
    eventLabel: 'Veranstaltung',
    areaLabel: 'Bereich',
    shiftLabel: 'Schicht',
    shiftLeadLabel: 'Leiter',
    declineHelperText: 'Wenn Sie auf "Ablehnen" klicken, wissen wir, dass Sie für diese Aufgabe nicht zur Verfügung stehen. Vielen Dank, dass Sie uns bei der Vorausplanung helfen.',
    dutiesNotYetAssignedMessage: 'Aufgaben werden zu gegebener Zeit zugewiesen. Bitte schauen Sie regelmäßig nach Updates.',
    // Accept/Decline modal
    acceptThankYouMessage: 'Vielen Dank, dass Sie Ihr Seva akzeptieren.',
    confirmAcceptMessage: 'Bitte bestätigen Sie, dass Sie dieses Seva annehmen möchten.',
    tknCheckboxLabel: 'Ich möchte diese Aufgabe als Teil von TKN anbieten. Aktivieren Sie dieses Kontrollkästchen nur, wenn Sie 2008 und/oder 2018 ein TKN Niyat angeboten haben.',
    ivTieScarfLabel: 'Für den Dienst während des Didar ist die IV-Krawatte/-Schal erforderlich. Besitzen Sie derzeit eine(n)?',
    ivTieScarfYes: 'Ja',
    ivTieScarfNo: 'Nein',
    confirmButton: 'Bestätigen',
    goBackButton: 'Zurückgehen',
    declineModalTitle: 'Aufgabe ablehnen',
    declineReasonLabel: 'Grund für die Ablehnung',
    declineReasonPlaceholder: 'Bitte wählen Sie einen Grund',
    declineDetailsLabel: 'Zusätzliche Details (optional)',
    declineDetailsPlaceholder: 'Bitte geben Sie zusätzliche Informationen an...',
    declineReasons: [
        'Die Zeit ist nicht passend (je nach Verfügbarkeit kann eine andere Schicht angeboten werden)',
        'Ich möchte diese spezielle Aufgabe nicht übernehmen (je nach Verfügbarkeit kann eine andere Schicht angeboten werden)',
        'Ich kann mich derzeit nicht festlegen (Ich werde das VRC an dem Tag besuchen)',
        'Ich möchte aus persönlichen Gründen nicht mehr weitermachen'
    ],
    submitDeclineButton: 'Absenden',
    cancelButton: 'Abbrechen',
    startTimeLabel: 'Startzeit',
    endTimeLabel: 'Endzeit'
}

export const EventsMeta: EventsMetaProps = {
    title: 'Veranstaltungen',
    description: 'Durchsuchen und verwalten Sie alle bevorstehenden Veranstaltungen',
    errorTitle: 'Fehler beim Laden von Veranstaltungen',
    noEventsMessage: 'Keine Veranstaltungen gefunden',
    noFilteredEventsMessage: 'Keine Veranstaltungen entsprechen dem aktuellen Filter',
    filterLabel: 'Schnellfilter',
    filterPlaceholder: 'Veranstaltungen nach Namen suchen...',
    filterPresetsLabel: 'Voreinstellungen',
    clearFilterButton: 'Löschen',
    createButton: 'Neue Veranstaltung erstellen'
}
export const VolunteersMeta: VolunteersMetaProps = {
    title: 'Freiwillige',
    description: 'Durchsuchen und verwalten Sie alle Freiwilligen',
    errorTitle: 'Fehler beim Laden der Freiwilligen',
    noEventsMessage: 'Kein Freiwilliger gefunden',
    createButton: 'Neuen Freiwilligen erstellen'
}
export const DutyMeta: DutyMetaProps = {
    title: 'Verfügbare Aufgaben',
    description: 'Durchsuchen und verwalten Sie alle verfügbaren Aufgaben',
    errorTitle: 'Fehler beim Laden der Aufgaben',
    noDutyMessage: 'Keine Aufgaben gefunden',
    dutySearchPlaceHolder: 'Aufgabe nach Titel suchen...',
    createButton: 'Neue Aufgabe erstellen'
}

export const LoadingSpinnerMeta: LoadingSpinnerMetaProps = {
    loadingText: 'Wird geladen...'
}

export const LoginMeta: LoginMetaProps = {
    ukResidentLoginButton: 'Über IIUK anmelden',
    internationalVisitorLoginButton: 'Freiwilligen-Community (nicht IIUK-registriert)',
    checkInLoginLink: 'Check-in-Anmeldung',
    helpText: () => <>{`Um auf das VMS zuzugreifen, melden Sie sich bitte mit Ihren IIUK-Anmeldedaten an.

Wenn Sie noch nicht bei IIUK registriert sind oder keinen Zugriff auf Ihr Konto haben, verwenden Sie bitte zuerst die Option „Passwort vergessen“, um den Zugriff auf IIUK wiederherzustellen. Sobald Ihr IIUK-Zugriff wiederhergestellt ist, können Sie sich beim VMS anmelden.

Sollten Sie weiterhin Probleme bei der Anmeldung haben oder Fragen haben, kontaktieren Sie uns bitte unter`} <a href="mailto:ivc@iiuk.org" className='underline text-primary-600'>ivc@iiuk.org</a>.</>,
    pendingApprovalTitle: 'Konto wartet auf Genehmigung'
}

export const EventCardMeta: EventCardMetaProps = {
    dateLabel: 'Datum',
    timeLabel: 'Zeit',
    locationLabel: 'Ort',
    areasLabel: 'Bereiche',
    addressLabel: 'Adresse',
    areasSingular: 'Bereich',
    areasPlural: 'Bereiche',
    viewDetailsButton: 'Details anzeigen',
    visibleLabel: 'Sichtbar',
    perAreaLabel: 'Pro Bereich',
    shiftsVisibleTooltip: 'Genehmigte Schichten dieser Veranstaltung sind für Freiwillige sichtbar (Sichtbarkeit auf Veranstaltungsebene aktiviert)',
    shiftsPerAreaTooltip: 'Die Sichtbarkeit von Schichten wird auf Bereichsebene gesteuert – prüfen Sie einzelne Bereiche'
}
export const VolunteerCardMeta: VolunteerCardMetaProps = {
    dateLabel: 'Datum',
    timeLabel: 'Zeit',
    locationLabel: 'Ort',
    areasLabel: 'Bereiche',
    addressLabel: 'Adresse',
    areasSingular: 'Bereich',
    areasPlural: 'Bereiche',
    viewDetailsButton: 'Details anzeigen'
}
export const DutyCardMeta: DutyCardMetaProps = {
    'nameLabel': 'Aufgabenname'
}

export const PreferenceMeta: PreferenceMetaProps = {
    title: 'Verfügbare Präferenzen',
    description: 'Durchsuchen und verwalten Sie alle Freiwilligenpräferenzen',
    errorTitle: 'Fehler beim Laden von Präferenzen',
    noPreferenceMessage: 'Keine Präferenzen gefunden',
    preferenceSearchPlaceHolder: 'Präferenz nach Name oder Kategorie suchen...',
    createButton: 'Neue Präferenz erstellen'
}

export const PreferenceCardMeta: PreferenceCardMetaProps = {
    nameLabel: 'Präferenzname',
    categoryLabel: 'Kategorie',
    descriptionLabel: 'Beschreibung'
}

export const EventDetailMeta: EventDetailMetaProps = {
    backToEventsButton: 'Zurück zu Veranstaltungen',
    areasTitle: 'Bereiche',
    noAreasMessage: 'Für diese Veranstaltung wurden keine Bereiche gefunden',
    shiftsTitle: 'Schichten',
    noShiftsMessage: 'Diesem Bereich sind keine Schichten zugewiesen',
    loadingText: 'Wird geladen...',
    errorTitle: 'Fehler',
    dateLabel: 'Datum',
    timeLabel: 'Zeit',
    startTimeLabel: 'Startzeit',
    endTimeLabel: 'Endzeit',
    capacityLabel: 'Kapazität',
    volunteersLabel: 'Freiwillige',
    maxVolunteersLabel: 'Max. Freiwillige',
    descriptionLabel: 'Beschreibung',
    locationLabel: 'Ort',
    addressLabel: 'Adresse',
    showShiftsButton: 'Schichten anzeigen',
    hideShiftsButton: 'Schichten verbergen',
    leadsTitle: "Veranstaltungsleiter",
    leadNameTitle: "Leiter Name",
    deputyLeadNameTitle: "Stellvertretender Leiter",
    contactTitle: "Kontakt",
    editEventButton: 'Veranstaltung bearbeiten',
    copyShiftAllocationsButton: 'Copy allocations',
    exportShiftRegionStatusButton: 'Schichtstatus exportieren',
    exportingShiftRegionStatusButton: 'Exportieren...',
    exportShiftRegionStatusError: 'Schichtstatusdaten konnten nicht exportiert werden',
    selectEmailCampaignsTitle: 'E-Mail-Kampagnen auswählen',
    selectEmailCampaignsDescription: 'Wählen Sie aus, welche gesendeten E-Mail-Kampagnen für die Spalten E-Mail gesendet J/N in diesem Export zählen sollen.',
    selectEmailCampaignsCancelButton: 'Abbrechen',
    selectEmailCampaignsExportButton: 'Ausgewählte Kampagnen exportieren',
    selectEmailCampaignsError: 'Bitte wählen Sie mindestens eine E-Mail-Kampagne für diesen Export aus.',
    emailCampaignLoadError: 'E-Mail-Kampagnen konnten nicht geladen werden',
    noEmailCampaignsMessage: 'Keine E-Mail-Kampagnen zur Auswahl verfügbar.',
    emailCampaignOptionDetails: (status, sentCount, createdAt) => `${status.replace('_', ' ')} • ${sentCount} gesendet • Erstellt ${new Date(createdAt).toLocaleDateString()}`,
    createAreaButton: 'Neuen Bereich erstellen',
    addShiftButton: 'Schicht hinzufügen',
    required_volunteer_count_label: 'Erforderliche Freiwillige',
    allocation_count_label: "Zugewiesene Freiwillige",
    leads_count_label: "Führungspositionen",
    multi_allocation_count_label: "Mit mehreren Zuweisungen",
    accepted_allocations_label: 'Akzeptiert',
    rejected_allocations_label: 'Abgelehnt',
    pending_allocations_label: 'Ausstehend',
    visibleLabel: 'Sichtbar',
    visibleViaEventLabel: 'Sichtbar über Veranstaltung',
    hiddenLabel: 'Verborgen',
    shiftsVisibleTooltip: 'Genehmigte Schichten in diesem Bereich sind für Freiwillige sichtbar (Sichtbarkeit auf Bereichsebene aktiviert)',
    shiftsVisibleViaEventTooltip: 'Genehmigte Schichten in diesem Bereich sind für Freiwillige sichtbar (über Sichtbarkeit auf Veranstaltungsebene)',
    shiftsHiddenTooltip: 'Schichten in diesem Bereich sind für Freiwillige unsichtbar (Sichtbarkeit auf Bereichs- oder Veranstaltungsebene aktivieren)'
}

export const EventFormModalMeta: EventFormModalMetaProps = {
    title: 'Neue Veranstaltung erstellen',
    nameLabel: 'Veranstaltungsname',
    namePlaceholder: 'Veranstaltungsnamen eingeben',
    organizerLabel: 'Organisator',
    organizerPlaceholder: 'Namen des Organisators eingeben',
    startDateLabel: 'Startdatum',
    endDateLabel: 'Enddatum',
    startTimeLabel: 'Startzeit',
    endTimeLabel: 'Endzeit',
    locationLabel: 'Ort',
    locationPlaceholder: 'Veranstaltungsort eingeben',
    addressLabel: 'Adresse',
    addressPlaceholder: 'Vollständige Adresse eingeben',
    cityLabel: 'Stadt',
    cityPlaceholder: 'Stadt eingeben',
    countryLabel: 'Land',
    countryPlaceholder: 'Land eingeben',
    submitButton: 'Veranstaltung erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Veranstaltung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    leadNamePlaceholder: 'Leiter Name',
    leadPhoneNumberPlaceHolder: 'Telefonnummer des Leiters',
    deputyLeadNamePlaceHolder: 'Name des stellvertretenden Leiters',
    deputyLeadPhoneNumberPlaceHolder: 'Telefonnummer des stellvertretenden Leiters',
    leadNameTitle: 'Leiter-Details',
    leadcontactTitle: 'Telefonnummer des Leiters',
    deputyLeadNameTitle: 'Details des stellv. Leiters',
    deputyLeadcontactTitle: 'Telefonnummer des stellv. Leiters',
    required_volunteer_count_title: 'Anzahl erforderlicher Freiwilliger',
    require_walkie_talkie_label: 'Walkie-Talkie erforderlich',
    shiftsVisibleLabel: 'Schichten für Freiwillige sichtbar',
    shiftsVisibleDescription: 'Wenn diese Option aktiviert ist, sind genehmigte Schichten dieser Veranstaltung für Freiwillige zur Annahme/Ablehnung sichtbar. Schichten müssen außerdem genehmigt (gesperrt) werden, um sichtbar zu sein.',
    includeInDuplicateChecksLabel: 'In Duplikatprüfungen einbeziehen',
    includeInDuplicateChecksDescription: 'Wenn diese Option aktiviert ist, zählen Zuweisungen dieser Veranstaltung zu den Duplikatprüfungen der Freiwilligen. Für Veranstaltungen deaktivieren, die die Duplikatzählung nicht beeinflussen sollen.',
}

export const DuplicateEventModalMeta: DuplicateEventModalMetaProps = {
    title: 'Veranstaltung duplizieren',
    nameLabel: 'Veranstaltungsname',
    namePlaceholder: 'Veranstaltungsnamen eingeben',
    startDateLabel: 'Startdatum',
    endDateLabel: 'Enddatum',
    startTimeLabel: 'Startzeit',
    endTimeLabel: 'Endzeit',
    submitButton: 'Veranstaltung duplizieren',
    submittingButton: 'Wird dupliziert...',
    cancelButton: 'Abbrechen',
    errorMessage: 'Veranstaltung konnte nicht dupliziert werden. Bitte versuchen Sie es erneut.',
    description: 'Dadurch wird eine Kopie der Veranstaltung einschließlich aller Bereiche und Schichten erstellt, jedoch ohne Freiwilligenzuweisungen. Sie können den Namen und die Daten für die neue Veranstaltung ändern.'
}

export const VolunteerFormModalMeta: VolunteerFormModalMetaProps = {
    title: 'Freiwilligeninformationen',
    nameLabel: 'Vorname',
    namePlaceholder: 'Vorname eingeben',
    lastNameLabel: 'Nachname',
    lastNamePlaceholder: 'Nachname eingeben',
    secondLastNameLabel: 'Zweiter Nachname',
    secondLastNamePlaceholder: 'Zweiten Nachnamen eingeben (optional)',
    genderLabel: 'Geschlecht',
    dobLabel: 'Geburtsdatum',
    contactLabel: 'Telefonnummer',
    contactPlaceholder: 'Telefonnummer eingeben',
    countryCodeLabel: 'Ländercode',
    EmailLabel: 'E-Mail',
    EmailPlaceholder: 'E-Mail-Adresse eingeben',
    CountryofResidence: 'Wohnsitzland',
    countryOfBirthLabel: 'Geburtsland',
    Jamatkhana: 'Jamatkhana',
    FamilyOriginLabel: 'Familienherkunft',
    serviceLocationLabel: 'Einsatzort',
    serviceRecordLabel: 'Bitte teilen Sie uns mit, ob Sie als uniformierter Freiwilliger oder nicht uniformierter Freiwilliger dienen möchten',
    languagesLabel: 'Sprachen',
    supportNeedsLabel: 'Besondere Unterstützungsbedürfnisse',
    supportNeedsPlaceholder: 'Bitte teilen Sie uns mit, ob Sie besondere Hilfe benötigen',
    volunteerStatusLabel: 'Freiwilligenstatus',
    ismailiLabel: 'Ismaili',
    multiFaithFamilyLabel: 'Interreligiöse Familie',
    registeredVolunteerLabel: 'Registrierter Freiwilliger',
    eligibleForDutyLabel: 'Berechtigt für Aufgabe',
    preferencesLabel: 'Präferenzen',
    flagsLabel: 'Zusätzliche Details für Freiwillige',
    submitButton: 'Absenden',
    submittingButton: 'Wird gesendet...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Profil konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.',
    volunteerForVisit: 'Möchten Sie während des Didar als Freiwilliger helfen?',
    availabilityLabel: 'Bitte geben Sie an, wie Sie helfen möchten (Mehrfachauswahl möglich):',
    negativeListLabel: "Kann Aufgaben nicht erfüllen",
    registrationNote: () => <>
        Bitte stellen Sie sicher, dass Sie sich (sofern berechtigt) über <Link to={`${IIUK_BASE_URL}`} className='font-medium underline inline-block break-inside-avoid' target='_blank'>IIUK <ExternalLinkIcon className='inline w-3.5 h-3.5' /></Link> oder The Ismaili App für das Europa Didar (Berlin) registriert haben.<br />
        Diese Registrierung dient <i>nur</i> der Freiwilligenverwaltung und stellt <i>keine</i> Anmeldung zum Europa Didar (Berlin) selbst dar.
    </>,
    registrationAckLabel: 'Ich verstehe',
    successMessage: 'Ihr Freiwilligenprofil wurde erfolgreich eingereicht.',
}

export const DutyFormModalMeta: DutyFormModalMetaProps = {
    title: 'Neue Aufgabe erstellen',
    nameLabel: 'Name',
    negativeListMemberLabel: 'In die Negativliste aufnehmen',
    namePlaceholder: 'Aufgabenname eingeben',
    submitButton: 'Aufgabe erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Aufgabe konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
}

export const PreferenceFormModalMeta: PreferenceFormModalMetaProps = {
    title: 'Neue Präferenz erstellen',
    nameLabel: 'Name',
    namePlaceholder: 'Präferenznamen eingeben',
    categoryLabel: 'Kategorie',
    categoryPlaceholder: 'Kategorie eingeben',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Beschreibung eingeben',
    submitButton: 'Präferenz erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Präferenz konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
}

export const DeleteDutyMeta: DeleteDutyMetaProps = {
    deleteButtonText: 'Aufgabe löschen',
    confirmTitle: 'Aufgabe löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diese Aufgabe löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt die ausgewählte Aufgabe.'
}

export const DeletePreferenceMeta: DeletePreferenceMetaProps = {
    deleteButtonText: 'Präferenz löschen',
    confirmTitle: 'Präferenz löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diese Präferenz löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt die ausgewählte Präferenz.'
}

export const FlagMeta: FlagMetaProps = {
    title: 'Verfügbare Markierungen',
    description: 'Alle Freiwilligen-Markierungen durchsuchen und verwalten',
    errorTitle: 'Fehler beim Laden von Markierungen',
    noFlagMessage: 'Keine Markierungen gefunden',
    flagSearchPlaceHolder: 'Markierung nach Name suchen...',
    createButton: 'Neue Markierung erstellen',
    categorySectionTitle: 'Markierungskategorien',
    noCategoryMessage: 'Keine Kategorien gefunden',
    createCategoryButton: 'Neue Kategorie erstellen'
}

export const CoreTeamMeta: CoreTeamMetaProps = {
    title: 'Kernteam',
    description: 'Kernteammitglieder in allen Streams anzeigen und verwalten',
    createButton: 'Kernteammitglied hinzufügen',
    errorTitle: 'Fehler beim Laden des Kernteams',
    noDataMessage: 'Keine Kernteammitglieder gefunden',
    loadingText: 'Kernteammitglieder werden geladen...'
}

export const CoreTeamStatsMeta: CoreTeamStatsMetaProps = {
    statsTitle: 'Statistiken',
    showStatsButton: 'Statistiken anzeigen',
    hideStatsButton: 'Statistiken verbergen',
    genderTitle: 'Geschlecht',
    regionTitle: 'Region',
    familyOriginTitle: 'Familienherkunft',
    londonLabel: 'London',
    notLondonLabel: 'Nicht-London',
    excludedReservedNote: '(Reservierte Stufe ausgeschlossen)',
    otherLabel: 'Andere'
}

export const CoreTeamTableMeta: CoreTeamTableMetaProps = {
    idColumn: 'ID',
    nameColumn: 'Name',
    streamsColumn: 'Streams',
    roleColumn: 'Rolle',
    tierColumn: 'Stufe',
    phoneColumn: 'Telefon',
    emailColumn: 'E-Mail',
    ismailiColumn: 'Ismaili',
    familyOriginColumn: 'Familienherkunft',
    ageBandColumn: 'Altersgruppe',
    notesColumn: 'Notizen',
    duplicationsColumn: 'Duplikate',
    submittedByColumn: 'Eingereicht von',
    statusColumn: 'Genehmigungsstatus',
    activityStatusColumn: 'Aktivitätsstatus',
    actionsColumn: 'Aktionen',
    approvedStatus: 'Genehmigt',
    pendingStatus: 'Eingereicht',
    activeStatus: 'Aktiv',
    onHoldStatus: 'Pausiert',
    approveButton: 'Genehmigen',
    rejectButton: 'Ablehnen',
    yesLabel: 'Ja',
    noLabel: 'Nein',
    viewAllocationsButton: (count: number) => `Duplikate anzeigen (${count})`,
    streamFilterLabel: 'Stream',
    allStreamsLabel: 'Alle Streams',
    tierFilterLabel: 'Stufe',
    allTiersLabel: 'Alle Stufen',
    statusFilterLabel: 'Genehmigungsstatus',
    allStatusLabel: 'Alle Status',
    activityStatusFilterLabel: 'Aktivitätsstatus',
    allActivityStatusLabel: 'Alle',
    duplicationsFilterLabel: 'Duplikate',
    anyDuplicationsLabel: 'Beliebige',
    hasDuplicationsLabel: 'Hat Duplikate',
    noDuplicationsLabel: 'Keine Duplikate',
    putOnHoldButton: 'Pausieren',
    makeActiveButton: 'Aktivieren',
    selectedCountLabel: (count: number) => `${count} ausgewählt`,
    clearSelectionLabel: 'Auswahl aufheben',
    bulkApproveLabel: 'Genehmigen',
    bulkApprovingLabel: 'Wird genehmigt...',
    bulkRejectLabel: 'Ablehnen',
    bulkRejectingLabel: 'Wird abgelehnt...',
    bulkUnapproveLabel: 'Genehmigung aufheben',
    bulkUnapprovingLabel: 'Genehmigung wird aufgehoben...',
    bulkDeleteLabel: 'Löschen',
    bulkDeletingLabel: 'Wird gelöscht...',
    bulkPutOnHoldLabel: 'Pausieren',
    bulkPuttingOnHoldLabel: 'Wird pausiert...',
    bulkMakeActiveLabel: 'Aktivieren',
    bulkMakingActiveLabel: 'Wird aktiviert...',
    previousPageLabel: 'Zurück',
    nextPageLabel: 'Weiter',
    pageInfoLabel: (start: number, end: number, total: number) => `Zeige ${start}–${end} von ${total}`,
    rowsPerPageLabel: 'Zeilen pro Seite',
    exportButton: 'Als CSV exportieren'
}

export const RejectedCoreTeamTableMeta: RejectedCoreTeamTableMetaProps = {
    title: 'Abgelehnte Kernteam-Einträge',
    nameColumn: 'Name',
    streamsColumn: 'Streams',
    roleColumn: 'Rolle',
    tierColumn: 'Stufe',
    rejectedByColumn: 'Abgelehnt von',
    rejectedDateColumn: 'Ablehnungsdatum',
    deleteButton: 'Löschen',
    deletingButton: 'Wird gelöscht...',
    noDataMessage: 'Keine abgelehnten Einträge gefunden',
    searchPlaceholder: 'Abgelehnte Einträge suchen...',
    clearFiltersButton: 'Löschen',
    exportButton: 'Als CSV exportieren'
}

export const CoreTeamFormModalMeta: CoreTeamFormModalMetaProps = {
    title: 'Kernteammitglied hinzufügen',
    volunteerLabel: 'Freiwilliger',
    submittedByLabel: 'Eingereicht von',
    streamsLabel: 'Streams',
    streamsSelectedLabel: 'Stream(s) ausgewählt',
    streamsRequiredError: 'Bitte wählen Sie mindestens einen Stream aus',
    statusLabel: 'Aktivitätsstatus',
    activeStatus: 'Aktiv',
    onHoldStatus: 'Pausiert',
    roleLabel: 'Rolle',
    rolePlaceholder: 'Rolle eingeben (z.B. ExCo, PMO)',
    roleRequiredError: 'Rolle ist erforderlich',
    tierLabel: 'Stufe',
    tierRequiredError: 'Stufe ist erforderlich',
    notesLabel: 'Notizen (optional)',
    notesPlaceholder: 'Zusätzliche Notizen eingeben',
    submitButton: 'Zur Genehmigung einreichen',
    submittingButton: 'Wird eingereicht...',
    cancelButton: 'Abbrechen',
    errorMessage: 'Kernteammitglied konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.'
}

export const CoreTeamAddModalMeta: CoreTeamAddModalMetaProps = {
    title: 'Freiwilligen zum Hinzufügen auswählen',
    nameSearchPlaceholder: 'Nach Name suchen...',
    emailSearchPlaceholder: 'Nach E-Mail suchen...',
    phoneSearchPlaceholder: 'Nach Telefon suchen...',
    idSearchPlaceholder: 'Nach ID suchen...',
    searchButton: 'Suchen',
    clearButton: 'Löschen',
    loadingText: 'Freiwillige werden geladen...',
    pagesLabel: 'Seiten',
    showingLabel: 'Zeige',
    volunteersLabel: 'Freiwillige',
    noResultsMessage: 'Keine Freiwilligen gefunden, die Ihrer Suche entsprechen',
    noVolunteersMessage: 'Alle Freiwilligen sind bereits im Kernteam',
    idColumn: 'ID',
    nameColumn: 'Name',
    phoneColumn: 'Telefon',
    emailColumn: 'E-Mail',
    jamatKhanaColumn: 'Jamatkhana',
    duplicationsColumn: 'Duplikate',
    viewDuplicationsButton: (count: number) => `Anzeigen (${count})`,
    actionColumn: 'Aktion',
    addButton: 'Hinzufügen',
    closeButton: 'Schließen',
    errorMessage: 'Freiwillige konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Duplikate für ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Schichtzuweisungen (${count})`,
    excludedAllocationsTitle: (count: number) => `Von Duplikatzählung ausgeschlossen (${count})`,
    excludedAllocationsDescription: 'Diese Zuweisungen stammen aus Veranstaltungen, die nicht in Duplikatprüfungen einbezogen sind.',
    coreTeamAssignmentsTitle: (count: number) => `Kernteam-Zuweisungen (${count})`,
    leadPositionsTitle: (count: number) => `Leiter -/Stellv. Leiter-Positionen (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Ausgeschlossene Leiter-Positionen (${count})`,
    excludedLeadPositionsDescription: 'Diese Leiterpositionen stammen aus Veranstaltungen, die nicht in Duplikatprüfungen einbezogen sind.',
    positionTypeColumn: 'Typ',
    statusColumn: 'Status',
    eventColumn: 'Veranstaltung',
    areaColumn: 'Bereich',
    shiftColumn: 'Schicht',
    dateTimeColumn: 'Datum/Uhrzeit',
    noDuplicationsMessage: 'Keine weiteren Zuweisungen oder Kernteamzuweisungen gefunden.',
    closeModalButton: 'Schließen',
    submittedStatus: 'Eingereicht',
    approvedStatus: 'Genehmigt',
    pendingStatus: 'Ausstehend',
    acceptedStatus: 'Akzeptiert',
    declinedStatus: 'Abgelehnt',
    roleColumn: 'Rolle',
    streamsColumn: 'Streams'
}

export const FlagCardMeta: FlagCardMetaProps = {
    nameLabel: 'Markierungsname',
    descriptionLabel: 'Beschreibung',
    hiddenFromRegistrationLabel: 'Vom Registrierung ausgeblendet'
}

export const FlagFormModalMeta: FlagFormModalMetaProps = {
    title: 'Neue Markierung erstellen',
    nameLabel: 'Name',
    categoryLabel: 'Kategorie',
    categoryPlaceholder: 'Eine Kategorie auswählen (optional)',
    noCategoryOption: 'Keine Kategorie',
    namePlaceholder: 'Markierungsnamen eingeben (z. B. Brandschutzausbildung, Medizinisches Personal)',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Markierungsbeschreibung eingeben',
    hasExpiryLabel: 'Hat Ablaufdatum',
    hiddenFromRegistrationLabel: 'Vom Registrierungsformular ausblenden',
    submitButton: 'Markierung erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Markierung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
}

export const UpdateFlagFormMeta: UpdateFlagFormMetaProps = {
    title: 'Markierung aktualisieren',
    submitButton: 'Markierung aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const DeleteFlagMeta: DeleteFlagMetaProps = {
    deleteButtonText: 'Markierung löschen',
    confirmTitle: 'Markierung löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diese Markierung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt die ausgewählte Markierung.'
}

export const FlagCategoryFormModalMeta: FlagCategoryFormModalMetaProps = {
    title: 'Neue Kategorie erstellen',
    nameLabel: 'Kategoriename',
    namePlaceholder: 'Kategorienamen eingeben',
    submitButton: 'Kategorie erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    errorMessage: 'Kategorie konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
}

export const UpdateFlagCategoryFormMeta: UpdateFlagCategoryFormMetaProps = {
    title: 'Kategorie aktualisieren',
    submitButton: 'Kategorie aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const DeleteFlagCategoryMeta: DeleteFlagCategoryMetaProps = {
    deleteButtonText: 'Löschen',
    confirmTitle: 'Kategorie löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diese Kategorie löschen möchten? Markierungen in dieser Kategorie werden nicht gelöscht, haben dann aber keine zugewiesene Kategorie.'
}

export const ConfirmationModalMeta: ConfirmationModalMetaProps = {
    confirmButton: 'Löschen',
    cancelButton: 'Abbrechen',
    deletingButton: 'Wird gelöscht...'
}

export const DeleteEventMeta: DeleteEventMetaProps = {
    deleteButtonText: 'Veranstaltung löschen',
    confirmTitle: 'Veranstaltung löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diese Veranstaltung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt alle zugehörigen Bereiche, Schichten und Zuweisungen.',
    detailDeleteButtonText: 'Veranstaltung löschen'
}

export const UpdateEventFormMeta: UpdateEventFormMetaProps = {
    title: 'Veranstaltung bearbeiten',
    submitButton: 'Veranstaltung aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const UpdateDutyFormMeta: UpdateDutyFormMetaProps = {
    title: 'Aufgabe bearbeiten',
    submitButton: 'Aufgabe aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const UpdatePreferenceFormMeta: UpdatePreferenceFormMetaProps = {
    title: 'Präferenz bearbeiten',
    submitButton: 'Präferenz aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const AreaFormModalMeta: AreaFormModalMetaProps = {
    title: 'Neuen Bereich erstellen',
    nameLabel: 'Bereichsname',
    namePlaceholder: 'Bereichsnamen eingeben',
    submitButton: 'Bereich erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Bereich konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    leadNameTitle: 'Leiter Name',
    leadcontactTitle: 'Telefonnummer des Leiters',
    deputyLeadNameTitle: 'Name des stellvertretenden Leiters',
    deputyLeadcontactTitle: 'Telefonnummer des stellvertretenden Leiters',
    leadNamePlaceholder: 'Leiter Name eingeben',
    leadPhoneNumberPlaceHolder: 'Telefonnummer des Leiters eingeben',
    deputyLeadNamePlaceHolder: 'Name des stellv. Leiters eingeben',
    deputyLeadPhoneNumberPlaceHolder: 'Telefonnummer des stellv. Leiters eingeben',
    required_volunteer_count_title: 'Erforderliche Freiwilligenanzahl',
    accessColorLabel: 'Zugriffsfarbe',
    require_walkie_talkie_label: 'Walkie-Talkie erforderlich',
    shiftsVisibleLabel: 'Schichten für Freiwillige sichtbar',
    shiftsVisibleDescription: 'Wenn diese Option aktiviert ist, sind genehmigte Schichten dieses Bereichs für Freiwillige zur Annahme/Ablehnung sichtbar. Schichten müssen außerdem genehmigt (gesperrt) werden, um sichtbar zu sein.',
}

export const UpdateAreaFormMeta: UpdateAreaFormMetaProps = {
    title: 'Bereich bearbeiten',
    submitButton: 'Bereich aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const DeleteAreaMeta: DeleteAreaMetaProps = {
    deleteButtonText: 'Bereich löschen',
    confirmTitle: 'Bereich löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diesen Bereich löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt alle zugehörigen Schichten und Zuweisungen.'
}

export const ShiftFormModalMeta: ShiftFormModalMetaProps = {
    title: 'Neue Schicht erstellen',
    dutyLabel: 'Aufgabentyp',
    dutyPlaceholder: 'Einen Aufgabentyp auswählen',
    startTimeLabel: 'Startzeit',
    endTimeLabel: 'Endzeit',
    submitButton: 'Schicht erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Schicht konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    leadNameTitle: 'Leiter Name',
    leadcontactTitle: 'Telefonnummer des Leiters',
    deputyLeadNameTitle: 'Name des stellvertretenden Leiters',
    deputyLeadcontactTitle: 'Telefonnummer des stellvertretenden Leiters',
    leadNamePlaceholder: 'Leiter Name eingeben',
    leadPhoneNumberPlaceHolder: 'Telefonnummer des Leiters eingeben',
    deputyLeadNamePlaceHolder: 'Name des stellv. Leiters eingeben',
    deputyLeadPhoneNumberPlaceHolder: 'Telefonnummer des stellv. Leiters eingeben',
    required_volunteer_count_lable: 'Erforderliche Freiwilligenanzahl',
    accessColorLabel: 'Zugriffsfarbe',
    require_walkie_talkie_label: 'Walkie-Talkie erforderlich',
    criteriaLabel: 'Kriterien (Optional)',
    criteriaPlaceHolder: 'Detaillierte Kriterien oder Notizen eingeben...',
    titleLabel: 'Titel',
    titlePlaceHolder: 'Schichttitel eingeben...',
    instructionLabel: 'Anweisungen (Optional)',
    instructionPlaceHolder: 'Geben Sie hier Ihre Anweisungen ein...'
}

export const UpdateShiftFormMeta: UpdateShiftFormMetaProps = {
    title: 'Schicht bearbeiten',
    submitButton: 'Schicht aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const DuplicateShiftModalMeta: DuplicateShiftModalMetaProps = {
    title: 'Schicht duplizieren',
    description: 'Kopien dieser Schicht erstellen. Sie können wählen, ob Freiwilligenzuweisungen einbezogen oder ausgeschlossen werden sollen, und ob sie in denselben Bereich oder eine andere Veranstaltung/einen anderen Bereich dupliziert werden sollen.',
    countLabel: 'Anzahl der Kopien',
    countPlaceholder: 'Anzahl eingeben (1-50)',
    countValidationError: 'Anzahl muss zwischen 1 und 50 liegen',
    includeAllocationsLabel: 'Freiwilligenzuweisungen einbeziehen',
    includeAllocationsDescription: 'Wenn diese Option aktiviert ist, werden alle aktuellen Freiwilligenzuweisungen in die neue(n) Schicht(en) kopiert.',
    destinationLabel: 'Ziel',
    sameAreaLabel: 'Selber Bereich',
    differentAreaLabel: 'Andere Veranstaltung/Anderer Bereich',
    eventLabel: 'Veranstaltung',
    selectEventPlaceholder: 'Eine Veranstaltung auswählen',
    areaLabel: 'Bereich',
    selectAreaPlaceholder: 'Einen Bereich auswählen',
    selectAreaError: 'Bitte wählen Sie einen Bereich für die duplizierte(n) Schicht(en)',
    submitButton: 'Duplizieren',
    submittingButton: 'Wird dupliziert...',
    cancelButton: 'Abbrechen',
    errorMessage: 'Schicht konnte nicht dupliziert werden. Bitte versuchen Sie es erneut.'
}

export const CopyShiftAllocationsModalMeta: CopyShiftAllocationsModalMetaProps = {
    title: 'Copy Shift Allocations',
    description: 'Copy the volunteers allocated to this shift into another shift. The destination shift times will be used and copied allocations will start as pending.',
    sourceShiftLabel: 'Source shift',
    eventLabel: 'Event',
    selectEventPlaceholder: 'Select an event',
    areaLabel: 'Area',
    selectAreaPlaceholder: 'Select an area',
    shiftLabel: 'Shift',
    selectShiftPlaceholder: 'Select a shift',
    selectShiftError: 'Please select a destination shift',
    noTargetShiftsMessage: 'No other shifts available in this area',
    loadEventsError: 'Failed to load events',
    submitButton: 'Copy Allocations',
    submittingButton: 'Copying...',
    cancelButton: 'Cancel',
    errorMessage: 'Failed to copy shift allocations. Please try again.'
}

export const DuplicateAreaModalMeta: DuplicateAreaModalMetaProps = {
    title: 'Bereich duplizieren',
    description: 'Kopien dieses Bereichs und aller zugehörigen Schichten erstellen. Sie können wählen, ob Freiwilligenzuweisungen einbezogen oder ausgeschlossen werden sollen, und ob in dieselbe oder eine andere Veranstaltung dupliziert werden soll.',
    countLabel: 'Anzahl der Kopien',
    countPlaceholder: 'Anzahl eingeben (1-50)',
    countValidationError: 'Anzahl muss zwischen 1 und 50 liegen',
    includeAllocationsLabel: 'Freiwilligenzuweisungen einbeziehen',
    includeAllocationsDescription: 'Wenn diese Option aktiviert ist, werden alle aktuellen Schichtzuweisungen in diesem Bereich in den/die neuen Bereich(e) kopiert.',
    destinationLabel: 'Ziel',
    sameEventLabel: 'Selbe Veranstaltung',
    differentEventLabel: 'Andere Veranstaltung',
    eventLabel: 'Veranstaltung',
    selectEventPlaceholder: 'Eine Veranstaltung auswählen',
    selectEventError: 'Bitte wählen Sie eine Veranstaltung für den/die duplizierten Bereich(e)',
    loadEventsError: 'Veranstaltungen konnten nicht geladen werden',
    submitButton: 'Duplizieren',
    submittingButton: 'Wird dupliziert...',
    cancelButton: 'Abbrechen',
    errorMessage: 'Bereich konnte nicht dupliziert werden. Bitte versuchen Sie es erneut.'
}

export const DeleteShiftMeta: DeleteShiftMetaProps = {
    confirmTitle: 'Schicht löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diese Schicht löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt alle zugehörigen Zuweisungen.'
}

export const TrainingListMeta: TrainingListMetaProps = {
    assignedTitle: 'Meine zugewiesenen Schulungen',
    availableTitle: 'Weitere verfügbare Schulungen',
    errorTitle: 'Fehler beim Laden von Schulungen',
    noAssignedTrainingsMessage: 'Ihnen sind derzeit keine Schulungen zugewiesen.',
    noAvailableTrainingsMessage: 'Es sind keine weiteren Schulungen verfügbar.',
    loadingText: 'Schulungen werden geladen...',
    modulesLabel: 'Module',
    durationLabel: 'Dauer',
    minutesSuffix: 'Min',
    mandatoryBadge: 'OBLIGATORISCH'
}

export const AdminTrainingsMeta: AdminTrainingsMetaProps = {
    title: 'Schulungen verwalten',
    description: 'Schulungsmodule für Freiwillige erstellen, bearbeiten und verwalten',
    errorTitle: 'Fehler beim Laden der Schulungen',
    noTrainingsMessage: 'Keine Schulungen verfügbar. Klicken Sie auf "Neue Schulung erstellen", um eine hinzuzufügen.',
    loadingText: 'Schulungen werden geladen...',
    assignVolunteersMessage: 'Freiwilligen zuweisen'
}

export const TrainingFormModalMeta: TrainingFormModalMetaProps = {
    title: 'Neue Schulung erstellen',
    nameLabel: 'Schulungsname',
    namePlaceholder: 'Schulungsnamen eingeben',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Schulungsbeschreibung eingeben',
    mandatoryLabel: 'Obligatorische Schulung',
    policyLabel: 'Richtlinie (wird nur bei Unvollständigkeit auf der Startseite angezeigt)',
    modulesLabel: 'Schulungsmodule',
    addModuleButton: 'Modul hinzufügen',
    removeModuleButton: 'Entfernen',
    moduleTypeLabel: 'Modultyp',
    moduleTitleLabel: 'Modultitel',
    moduleTitlePlaceholder: 'Modultitel eingeben',
    moduleUrlLabel: 'URL',
    moduleUrlPlaceholder: 'https://example.com/ressource',
    moduleFileLabel: 'Datei',
    moduleFilePlaceholder: 'Keine Datei ausgewählt',
    moduleFileUploadButton: 'Datei hochladen',
    moduleFileUploadingButton: 'Wird hochgeladen...',
    moduleFileRemoveButton: 'Datei entfernen',
    moduleContentTypeLabel: 'Inhaltstyp',
    moduleContentTypeUrl: 'URL',
    moduleContentTypeFile: 'Datei-Upload',
    moduleContentTypeLibrary: 'Bibliothek',
    browseLibraryButton: 'Bibliothek durchsuchen',
    libraryBrowserTitle: 'Video aus Bibliothek auswählen',
    libraryBrowserSelectButton: 'Video auswählen',
    libraryBrowserCancelButton: 'Abbrechen',
    libraryBrowserLoadingText: 'Videos werden geladen...',
    libraryBrowserErrorText: 'Videos konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
    libraryBrowserNoVideosText: 'Noch keine Videos in der Bibliothek.',
    moduleDescriptionLabel: 'Beschreibung (Optional)',
    moduleDescriptionPlaceholder: 'Modulbeschreibung eingeben',
    moduleDurationLabel: 'Dauer (Minuten)',
    moduleDurationPlaceholder: '15',
    moduleOrderPlaceholder: '0',
    moduleRequiredLabel: 'Erforderlich',
    noModulesMessage: 'Noch keine Module hinzugefügt. Klicken Sie auf "Modul hinzufügen", um Ihr erstes Modul zu erstellen.',
    submitButton: 'Schulung erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Schulung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    questionsLabel: 'Schulungsfragen',
    addQuestionButton: 'Frage hinzufügen',
    noQuestionMessage: 'Noch keine Fragen hinzugefügt. Klicken Sie auf "Frage hinzufügen", um Ihre erste Frage zu erstellen.',
    questionLable: 'Frage',
    questionPlaceHolder: 'Frage hier eingeben',
    answerDescriptionLabel: 'Antwortbeschreibung (Optional)',
    answerDescriptionPlaceholder: 'Zusätzlichen Kontext oder Erklärungen zu dieser Frage angeben',
    optionLabel: 'Option',
    addOptionButton: 'Option hinzufügen',
    noOptionMessage: 'Noch keine Optionen hinzugefügt. Klicken Sie auf "Option hinzufügen", um Ihre erste Option zu erstellen.',
    optionPlaceHolder: 'Option hier eingeben',
    optionsLabel: 'Optionen',
    optionSelectionMessage: 'Bitte wählen Sie die Option aus, die die Antwort ist.',
    noOptionsDisplayMessage: 'Für diese Frage sind keine Optionen verfügbar.'
}

export const UpdateTrainingFormMeta: UpdateTrainingFormMetaProps = {
    title: 'Schulung bearbeiten',
    submitButton: 'Schulung aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const DocumentViewerMeta: DocumentViewerMetaProps = {
    loadingText: 'Dokument wird geladen...',
    errorTitle: 'Fehler beim Laden des Dokuments',
    errorInvalidUrl: 'Ungültige Dokument-URL angegeben.',
    errorLoadingDocument: 'Das Dokument konnte nicht geladen werden. Bitte versuchen Sie es erneut.'
}

export const VideoPlayerMeta: VideoPlayerMetaProps = {
    loadingText: 'Video wird geladen...',
    errorTitle: 'Fehler beim Laden des Videos',
    errorInvalidUrl: 'Ungültige Video-URL angegeben.',
    errorLoadingVideo: 'Das Video konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    muteLabel: 'Stumm',
    unmuteLabel: 'Ton an',
    enterFullscreenLabel: 'Vollbild',
    exitFullscreenLabel: 'Vollbild beenden',
    playbackSpeedLabel: 'Geschwindigkeit',
    captionsLabel: 'Untertitel'
}

export const UnsupportedModuleViewerMeta: UnsupportedModuleViewerMetaProps = {
    title: 'Modultyp wird nicht unterstützt',
    message: 'Die Anzeige von {type}-Modulen wird derzeit nicht unterstützt.',
    supportedTypes: 'Derzeit unterstützt: Dokument (PDF), Video (YouTube, Vimeo, etc.)'
}

export const TrainingModulePageMeta: TrainingModulePageMetaProps = {
    backButtonLabel: 'Zurück zu Schulungsdetails',
    moduleLabel: 'Modul {current} von {total}',
    previousModuleButton: 'Vorheriges Modul',
    nextModuleButton: 'Nächstes Modul',
    errorTitle: 'Fehler beim Laden des Moduls',
    errorInvalidParameters: 'Ungültige Schulungs- oder Modulparameter.',
    errorTrainingNotFound: 'Schulung nicht gefunden.',
    errorModuleNotFound: 'Modul in dieser Schulung nicht gefunden.',
    errorInvalidContent: 'Ungültiges Schulungsinhaltsformat.',
    errorFileNotFound: 'Dokumentdatei nicht gefunden.',
    errorNoDocumentSource: 'Keine Dokument-URL oder Datei für dieses Modul angegeben.',
    errorNoVideoSource: 'Keine Video-URL oder Datei für dieses Modul angegeben.',
    errorGeneric: 'Beim Laden des Moduls ist ein Fehler aufgetreten.',
    documentViewer: DocumentViewerMeta,
    videoViewer: VideoPlayerMeta,
    unsupportedViewer: UnsupportedModuleViewerMeta
}

export const TrainingModuleMeta: TrainingModuleMetaProps = {
    minutesSuffix: 'Min'
}

export const VolunteerTrainingPageMeta: VolunteerTrainingPageMetaProps = {
    title: "Ihre zugewiesenen Schulungen",
    description: "Greifen Sie auf Ihre zugewiesenen Schulungsmodule zu und schließen Sie diese ab",
    errorTitle: "Fehler",
    noTrainingMessage: "Ihnen wurden noch keine Schulungen zugewiesen.",
    viewButton: "Schulung ansehen",
}

export const VolunteerPoliciesMeta: VolunteerPoliciesMetaProps = {
    title: "Richtlinien",
    description: "Überprüfen und bestätigen Sie erforderliche Richtlinien",
    errorTitle: "Fehler",
    noPoliciesMessage: "Ihnen wurden noch keine Richtlinien zugewiesen.",
    outstandingTitle: "Ausstehende Richtlinien",
    acknowledgedTitle: "Bestätigte Richtlinien",
    viewButton: "Richtlinie ansehen",
}

export const VolunteerTrainingPageDetailsMeta: VolunteerTrainingPageDetailsMetaProps = {
    backToTrainingsButton: 'Zurück zu Schulungen',
    loadingText: 'Schulung wird geladen',
    errorTitle: 'Fehler beim Laden der Schulungsdetails.',
    modulesLabel: 'Module',
    totalDurationLabel: 'Gesamtdauer',
    minutesSuffix: 'Min',
    mandatoryBadge: 'Obligatorisch',
    completedBadge: 'Abgeschlossen',
    inProgressBadge: 'In Bearbeitung',
    moduleNumberPrefix: 'Modul',
    completeTrainingButton: 'Als abgeschlossen markieren',
    trainingCompletedMessage: 'Diese Schulung wurde erfolgreich abgeschlossen.',
}

export const ModuleCompletionModalMeta: CompletionQuestionsModalMetaProps = {
    title: "Modulfragen",
    submitButton: "Antworten einreichen",
    submittingButton: "Modul wird abgeschlossen",
    cancelButton: "Abbrechen"
}

export const ProfileMeta: VolunteerProfileMetaProps = {
    loadingText: 'Wird geladen...',
    errorTitle: 'Fehler',
    backToVolunteersButton: 'Zurück zu Freiwilligen',
    editProfileButton: 'Profil bearbeiten',
    completeProfileButton: 'Profil vervollständigen',
    noAreasMessage: '',
    csid: 'Freiwilligen-ID',
    first_name: 'Vorname',
    last_name: 'Nachname',
    second_last_name: 'Zweiter Nachname',
    gender: 'Geschlecht',
    dob: 'Geburtsdatum',
    age: 'Alter',
    email: 'E-Mail',
    phone: 'Telefon',
    country_code: 'Ländercode',
    country: 'Land',
    country_of_birth: 'Geburtsland',
    jamat_khana: 'Jamatkhana',
    service_location: 'Einsatzort',
    service_record: 'IV-Position',
    family_origin: 'Familienherkunft',
    languages: 'Sprachen',
    support_needs: 'Besondere Unterstützungsbedürfnisse',
    multi_faith_family: 'Interreligiöse Familie',
    ismaili: 'Ismaili',
    registered_volunteer_label: 'Registrierter Freiwilliger',
    eligible_for_duty_label: 'Berechtigt für Aufgabe',
    yes: 'Ja',
    no: 'Nein',
    personalInfoSection: 'Persönliche Informationen',
    locationSection: 'Standortinformationen',
    additionalInfoSection: 'Freiwilligeninformationen',
    preferencesSection: 'Präferenzen',
    flagsSection: 'Zusätzliche Informationen',
    trainingsSection: 'Zugewiesene Schulungen',
    deleteTrainingMessage: 'Sind Sie sicher? Diese Schulung wird vom Freiwilligen getrennt und alle damit verbundenen Fortschritte gehen verloren.',
    deleteTrainingTitle: 'Schulungszuweisung aufheben',
    languageSection: 'Sprachen',
    volunteer_for_visit_label: 'Möchten Sie für das Didar freiwillig helfen?',
    availability_label: 'Verfügbarkeit',
    uploadedDocumentsLabel: "Hochgeladene Dokumente",
    allocatedShiftsLabel: "Zuweisungen",
    eventLeadLabel: "Veranstaltungsleiter",
    areaLeadLabel: "Bereichsleiter",
    shiftLeadLabel: "Schichtleiter",
    otherAllocationLabel: "Andere",
    negativeListLabel: "Kann Aufgaben nicht erfüllen"
}

export const VolunteerTableMeta = {
    columns: [
        { key: "csid", header: "VID" },
        { key: "first_name", header: "Vorname" },
        { key: "last_name", header: "Nachname" },
        { key: "email", header: "E-Mail" },
        { key: "phone", header: "Telefonnummer" },
        { key: "gender", header: "Geschlecht" },
        //{ key: "dob", header: "DOB" },
        { key: "age", header: "Alter" },
        { key: "country_of_birth", header: "Geburtsland" },
        { key: "family_origin", header: "Familienherkunft" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "service_record", header: "IV-Position" },
        { key: "ismaili", header: "Ismaili" },
        { key: "multi_faith_family", header: "Interreligiöse Familie" },
        { key: "eligible_for_duty", header: "Berechtigt für Aufgabe" },
        { key: "languages", header: "Sprachen" },
        { key: "preferences", header: "Präferenzen" },
        { key: "flags", header: "Zusätzliche Fähigkeiten" },
        //{ key: "support_needs", header: "Special Support" },
    ],
};


export const VolunteerTrainingTableMeta = {
    columns: [
        { key: "csid", header: "VID" },
        { key: "first_name", header: "Vorname" },
        { key: "last_name", header: "Nachname" },
        { key: "gender", header: "Geschlecht" },
        //{ key: "dob", header: "DOB" },
        // { key: "age", header: "Age" },
        { key: "service_record", header: "IV-Position" },
        { key: "preferences", header: "Präferenzen" },
        { key: "flags", header: "Zusätzliche Fähigkeiten" },
    ],
};

export const VolunteerAllocationTableMeta = {
    columns: [
        { key: "first_name", header: "Vorname" },
        { key: "last_name", header: "Nachname" },
        // { key: "gender", header: "Gender" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Familienherkunft" },
        { key: "service_record", header: "IV-Position" },
        { key: "flags", header: "Zusätzliche Fähigkeiten" },
    ],
};

export const ConflictInformationTableMeta = {
    columns: [
        { key: "event_name", header: "Veranstaltung" },
        { key: "area_name", header: "Bereich" },
        { key: "shift_title", header: "Schicht" },
        { key: "shift_duty_name", header: "Aufgabe" },
        { key: "start_time", header: "Schicht Start" },
        { key: "end_time", header: "Schicht Ende" },
        { key: "type", header: "Grund" },
        { key: "action", header: "Aktionen" },
    ],
};

export const VolunteerAllocationViewTableMeta = {
    columns: [
        { key: "first_name", header: "Vorname" },
        { key: "last_name", header: "Nachname" },
        { key: "phone", header: "Telefonnummer" },
        { key: "age_band", header: "Altersgruppe" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Familienherkunft" },
        { key: "service_record", header: "IV-Position" },
        { key: "flags", header: "Zusätzliche Fähigkeiten" },
        { key: "support_needs", header: "Unterstützungsbedarf" },
        { key: "action", header: "Aktionen" },
    ],
};

export const VolunteerEventShiftViewTableMeta = {
    columns: [
        { key: "event_name", header: "Veranstaltung" },
        { key: "area_name", header: "Bereich" },
        { key: "shift_duty_name", header: "Schicht" },
        { key: "start_time", header: "Schicht Start" },
        { key: "end_time", header: "Schicht Ende" },
        { key: "status", header: "Status" },
        { key: "action", header: "Aktion" }
    ],
};

export const VolunteerAreaShiftViewTableMeta = {
    columns: [
        { key: "shift_duty_name", header: "Schicht" },
        { key: "start_time", header: "Schicht Start" },
        { key: "end_time", header: "Schicht Ende" },
        { key: "status", header: "Status" },
        { key: "action", header: "Aktion" }
    ],
};


export const LeadAssginmentViewTableMeta = {
    columns: [
        { key: "first_name", header: "Vorname" },
        { key: "last_name", header: "Nachname" },
        { key: "email", header: "E-Mail" },
        { key: "phone", header: "Telefonnummer" },
        { key: "flags", header: "Zusätzliche Fähigkeiten" },
    ],
};

export const MIVolunteerViewMeta = {
    columns: [
        { key: "first_name", header: "Vorname" },
        { key: "last_name", header: "Nachname" },
        { key: "email", header: "E-Mail" },
        { key: "phone", header: "Telefonnummer" },
        { key: "jamat_khana", header: "Jamatkhana" },
        { key: "family_origin", header: "Familienherkunft" },
        { key: "service_record", header: "IV-Position" },
        { key: "uk_didar_registration_ack", header: "Didar-Bestätigung" }

    ],
};



export const AssignTrainingFormModalMeta: AssignTrainingFormModalMetaProps = {
    title: "Schulungen an Freiwilligen zuweisen",
    submitButton: "Zuweisen",
    submittingButton: "Wird zugewiesen",
    cancelButton: "Abbrechen",
    trainingLabel: "Verfügbare Schulungen",
    trainingPlaceHolder: "Schulung auswählen",
    addTrainingButton: "Schulung hinzufügen",
    noTrainingMessage: 'Noch keine Schulungen hinzugefügt. Klicken Sie auf "Schulung hinzufügen", um Ihre erste Schulung hinzuzufügen.',
    noTrainingSelectedMessage: 'Fügen Sie mindestens eine Schulung hinzu, um sie zuzuweisen.'
}

export const AnnouncementMeta: AnnouncementMetaProps = {
    title: 'Ankündigungen',
    description: 'Verwalten Sie alle Ankündigungen, die an die Freiwilligen gemacht wurden.',
    createButton: 'Neu posten',
    submitButton: 'Posten',
    submittingButton: 'Wird gepostet...',
    errorTitle: 'Fehler beim Abrufen der Ankündigungen',
    noAnnouncementsMessage: 'Es wurden noch keine Ankündigungen gepostet.',
    announcementSearchPlaceHolder: 'Ankündigung nach Titel suchen...',
    backButton: 'Zurück zum Admin-Hub',
    onDeleteTitle: 'Ankündigung löschen',
    onDeleteMessage: 'Das Löschen dieser Ankündigung entfernt sie dauerhaft für alle Benutzer. Diese Aktion kann nicht rückgängig gemacht werden.'
}

export const AnnouncementsFormModalMeta: AnnouncementFormModalMetaProps = {
    errorMessage: 'Fehler beim Posten des Formulars aufgetreten',
    createTitle: 'Neue Ankündigung posten',
    editTitle: 'Details zur Ankündigung',
    cancelButton: 'Abbrechen',
    submitButton: 'Posten',
    submittingButton: 'Wird gepostet...',
    titleLabel: 'Titel',
    titlePlaceHolder: 'Titel der Ankündigung eingeben...',
    contentLabel: 'Inhalt',
    contentPlaceHolder: 'Inhalt der Ankündigung eingeben...',
    prioritiyMessage: 'Als Priorität markieren'
}

export const AnnouncementViewModalMeta: AnnouncementViewModalMetaProps = {
    viewTitle: 'Ankündigung',
    titleLabel: 'Titel',
    contentLabel: 'Inhalt',
    prioritiyMessage: 'Dies ist eine prioritäre Ankündigung.',
    cancelButton: 'Schließen'
}

export const BulkTrainingAssignmentFormMeta: BulkTrainingAssignmentFormMetaProps = {
    title: 'Zuweisen ',
    cancelButton: 'Abbrechen',
    submitButton: 'Schulung zuweisen',
    submittingButton: 'Wird zugewiesen...',
    previewButton: 'Vorschau',
    previewingButton: 'Wird geladen...',
    // Assignment mode selection
    assignmentModeLabel: 'Zuweisungsmethode',
    modeAllVolunteers: 'Alle registrierten Freiwilligen',
    modeAllVolunteersDescription: 'Allen im System genehmigten Freiwilligen zuweisen',
    modeByEvent: 'Nach Veranstaltung',
    modeByEventDescription: 'Freiwilligen zuweisen, die bestimmten Veranstaltungen zugeteilt sind',
    modeByArea: 'Nach Bereich',
    modeByAreaDescription: 'Freiwilligen zuweisen, die bestimmten Bereichen zugeteilt sind',
    modeByShift: 'Nach Schicht',
    modeByShiftDescription: 'Freiwilligen zuweisen, die bestimmten Schichten zugeteilt sind',
    modeByDuty: 'Nach Aufgabentyp',
    modeByDutyDescription: 'Freiwilligen zuweisen, die Schichten mit bestimmten Aufgabentypen zugeteilt sind',
    modeManual: 'Manuelle Auswahl',
    modeManualDescription: 'Einzelne Freiwillige manuell filtern und auswählen',
    // Selection labels
    selectEventsLabel: 'Veranstaltungen auswählen',
    selectAreasLabel: 'Bereiche auswählen',
    selectShiftsLabel: 'Schichten auswählen',
    selectDutiesLabel: 'Aufgabentypen auswählen',
    // Lead inclusion options
    includeLeadsLabel: 'Leiter einbeziehen',
    includeEventLeadsLabel: 'Veranstaltungsleiter einbeziehen',
    includeAreaLeadsLabel: 'Bereichsleiter einbeziehen',
    includeShiftLeadsLabel: 'Schichtleiter einbeziehen',
    // Preview results
    previewResultsTitle: 'Vorschau',
    totalVolunteersLabel: 'Gesamtzahl der Freiwilligen, die den Kriterien entsprechen',
    alreadyAssignedLabel: 'Haben diese Schulung bereits',
    willBeAssignedLabel: 'Wird zugewiesen',
    // Messages
    noSelectionMessage: 'Bitte wählen Sie mindestens ein Element aus',
    selectEventFirst: 'Wählen Sie zuerst eine Veranstaltung, um Bereiche zu sehen',
    selectAreaFirst: 'Wählen Sie zuerst einen Bereich, um Schichten zu sehen'
}

export const ShiftAssignmentFormMeta: ShiftAssignmentFormMetaProps = {
    title: 'Freiwillige zuweisen',
    cancelButton: 'Abbrechen',
    submitAllocateButton: 'Zuweisen',
    submittingAllocateButton: 'Wird zugewiesen...',
    submitRemoveButton: 'Entfernen',
    submittingRemoveButton: 'Wird entfernt...',
    conflictTitle: 'Konfligierende Schichten',
    conflictMessage: 'Die folgenden Schichten stehen im Konflikt mit dieser Zuweisung.',
    futureConflictMessage: 'Die folgenden Schichten werden mit dieser Zuweisung in Konflikt geraten.',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Duplikate für ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Schichtzuweisungen (${count})`,
    excludedAllocationsTitle: (count: number) => `Von Duplikatzählung ausgeschlossen (${count})`,
    excludedAllocationsDescription: 'Diese Zuweisungen stammen aus Veranstaltungen, die nicht in Duplikatprüfungen einbezogen sind.',
    coreTeamAssignmentsTitle: (count: number) => `Kernteam-Zuweisungen (${count})`,
    leadPositionsTitle: (count: number) => `Leiter-/Stellv. Leiter-Positionen (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Ausgeschlossene Leiter-Positionen (${count})`,
    excludedLeadPositionsDescription: 'Diese Leiterpositionen stammen aus Veranstaltungen, die nicht in Duplikatprüfungen einbezogen sind.',
    positionTypeColumn: 'Typ',
    statusColumn: 'Status',
    eventColumn: 'Veranstaltung',
    areaColumn: 'Bereich',
    shiftColumn: 'Schicht',
    actionsColumn: 'Aktionen',
    dateTimeColumn: 'Datum/Uhrzeit',
    noDuplicationsMessage: 'Keine weiteren Zuweisungen oder Kernteamzuweisungen gefunden.',
    closeModalButton: 'Schließen',
    submittedStatus: 'Eingereicht',
    approvedStatus: 'Genehmigt',
    pendingStatus: 'Ausstehend',
    acceptedStatus: 'Akzeptiert',
    declinedStatus: 'Abgelehnt',
    roleColumn: 'Rolle',
    streamsColumn: 'Streams',
    publishShiftTitle: 'Schicht zur Genehmigung einreichen?',
    publishShiftMessage: 'Sobald diese Schicht eingereicht wurde, können keine weiteren Zuweisungen mehr vorgenommen oder entfernt werden.',
    publishButton: 'Zur Genehmigung einreichen',
    lockButton: 'Sperren',
    unlockButton: 'Entsperren'
}

export const AllLanguages = [
    "Arabic",
    "Persian / Farsi",
    "Bengali",
    "English",
    "Gujarati / Kutchi",
    "Urdu / Hindi",
    "Punjabi / Sindhi",
    "French",
    "German",
    "Mandarin Chinese / Japanese",
    "Portuguese",
    "Russian",
    "Spanish",
    "Swahili",
    "Turkish",
    "Tajik",

    "Danish",
    "Swedish",
    "Norwegian",
    "Finish",
    "Dutch",
    "Polish",
    "Italian",
]

export const IVPositions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer"
]

export const IVPositionFilterOptions = [
    "Non-Uniformed Volunteer",
    "Uniformed Volunteer",
    "Volunteer",
    "Junior Volunteer",
    "Team Leader",
    "JV Team Leader",
    "Deputy JV Team Leader",
    "Director",
    "Deputy Director",
    "IV Executive",
    "IV Events",
    "Other"
]

export const GenderOptions = [
    "Male",
    "Female",
    "Prefer Not to Say"
]

export const UserMetaProps = {
    title: 'Benutzerverwaltung',
    description: 'Benutzer und Rollen mit Zugriffskontrolle verwalten',
    errorTitle: 'Fehler beim Laden von Benutzern',
}
export const UserFormModalMeta: UserFormModalMetaProps = {
    title: 'Neuen Benutzer erstellen',
    nameLabel: 'Vollständiger Name',
    namePlaceholder: 'Vollständigen Namen eingeben',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'E-Mail-Adresse eingeben',
    roleLabel: 'Rolle',
    rolePlaceholder: 'Rolle auswählen',
    submitButton: 'Benutzer erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Benutzer konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    usernameLabel: 'Benutzername',
    usernamePlaceholder: 'Benutzername',
}

export const UpdateUserFormMeta: UpdateUserFormMetaProps = {
    title: 'Benutzer bearbeiten',
    submitButton: 'Benutzer aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}
export const DeleteUserMeta: DeleteUserMetaProps = {
    deleteButtonText: 'Benutzer löschen',
    confirmTitle: 'Benutzer löschen',
    confirmMessage: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und entfernt den ausgewählten Benutzer.'
}
export const DEFAULT_FILTERS: VolunteerFiltersWithConflictProps = {
    name: "",
    email: "",
    phone_number: "",
    id: "",
    country: "eu",
    age: null,
    country_of_birth: "",
    family_origin: "",
    jamat_khana: "",
    iv_position: "",
    ismaili: null,
    registered_volunteer: null,
    profile_submitted: true,
    approved_volunteer: null,
    eligible_for_duty: true,
    multi_faith_family: null,
    has_support_needs: null,
    tags: [],
    preferences: [],
    languages: [],
    service_record: [],
    genders: [],
    trainings: [],
    training_filter_type: 'at_least_one',
    age_start: 18,
    age_end: null,
    conflict: null,
    status: null,
    volunteer_for_visit: 1,
    iiuk_registeration: "any", // "iiuk"
    availability: [],
    availability_filter_type: 'at_least_one',
    event_assignment_type: null,
    event_assignment_events: [],
    documents: [],
    allocation_status: [],
    core_team_assignment_type: null,
    clusters: []
};

export const LeadAssignModalMeta: LeadAssignModalPropsMeta = {
    cancelButton: "Abbrechen",
    selectButton: "Auswählen",
    nameSearchPlaceholder: 'Nach Name suchen...',
    emailSearchPlaceholder: 'Nach E-Mail suchen...',
    phoneSearchPlaceholder: 'Nach Telefon suchen...',
    idSearchPlaceholder: 'Nach ID suchen...',
    searchButton: 'Suchen',
    clearButton: 'Löschen',
    showingLabel: 'Zeige',
    volunteersLabel: 'Freiwillige',
    noResultsMessage: 'Keine Freiwilligen gefunden, die Ihrer Suche entsprechen',
    noVolunteersMessage: 'Keine Freiwilligen verfügbar',
    idColumn: 'ID',
    nameColumn: 'Name',
    phoneColumn: 'Telefon',
    emailColumn: 'E-Mail',
    jamatKhanaColumn: 'Jamatkhana',
    duplicationsColumn: 'Duplikate',
    viewDuplicationsButton: (count: number) => `Anzeigen (${count})`,
    actionColumn: 'Aktion',
    duplicationsModalTitle: (firstName: string, lastName: string) => `Duplikate für ${firstName} ${lastName}`,
    shiftAllocationsTitle: (count: number) => `Schichtzuweisungen (${count})`,
    excludedAllocationsTitle: (count: number) => `Von Duplikatzählung ausgeschlossen (${count})`,
    excludedAllocationsDescription: 'Diese Zuweisungen stammen aus Veranstaltungen, die nicht in Duplikatprüfungen einbezogen sind.',
    coreTeamAssignmentsTitle: (count: number) => `Kernteam-Zuweisungen (${count})`,
    leadPositionsTitle: (count: number) => `Leiter-/Stellv. Leiter-Positionen (${count})`,
    excludedLeadPositionsTitle: (count: number) => `Ausgeschlossene Leiter-Positionen (${count})`,
    excludedLeadPositionsDescription: 'Diese Leiterpositionen stammen aus Veranstaltungen, die nicht in Duplikatprüfungen einbezogen sind.',
    positionTypeColumn: 'Typ',
    statusColumn: 'Status',
    eventColumn: 'Veranstaltung',
    areaColumn: 'Bereich',
    shiftColumn: 'Schicht',
    dateTimeColumn: 'Datum/Uhrzeit',
    noDuplicationsMessage: 'Keine weiteren Zuweisungen oder Kernteamzuweisungen gefunden.',
    closeModalButton: 'Schließen',
    submittedStatus: 'Eingereicht',
    approvedStatus: 'Genehmigt',
    pendingStatus: 'Ausstehend',
    acceptedStatus: 'Akzeptiert',
    declinedStatus: 'Abgelehnt',
    roleColumn: 'Rolle',
    streamsColumn: 'Streams'
}

export const AccessColorMeta: AccessColorMetaProps = {
    title: 'Zugriffsfarben',
    description: 'Alle Zugriffsfarben verwalten.',
    createButton: 'Neu erstellen',
    submitButton: 'Erstellen',
    submittingButton: 'Wird erstellt...',
    errorTitle: 'Fehler beim Abrufen der Zugriffsfarben',
    noAnnouncementsMessage: 'Es wurden noch keine Zugriffsfarben erstellt.',
    backButton: 'Zurück zum Admin-Hub',
    onDeleteTitle: 'Zugriffsfarbe löschen',
    onDeleteMessage: 'Das Löschen dieses Zugriffs entfernt ihn dauerhaft für alle Benutzer. Diese Aktion kann nicht rückgängig gemacht werden.'
}

export const AccessColorFormModalMeta: AccessColorFormModalMetaProps = {
    title: 'Neue Zugriffsfarbe erstellen',
    submitButton: 'Farbe erstellen',
    submittingButton: 'Wird erstellt...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    errorMessage: 'Zugriffsfarbe konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
    colorLabel: 'Ausgewählte Farbe',
    presetColorLabel: "Voreingestellte Farben",
    updateButton: 'Farbe aktualisieren',
    updatingButton: 'Wird aktualisiert...'

}

export const COLOR_PRESETS = [
    '#EF4444', // red
    '#F97316', // orange
    '#FACC15', // yellow
    '#22C55E', // green
    '#3B82F6', // blue
    '#6366F1', // indigo
    '#8B5CF6', // purple
    '#EC4899', // pink
    '#6B7280', // gray
];

export const AVAILABILITY_OPTIONS = [
    "Setup Support (3rd July)",
    "Pre Didar (4th July)",
    "Didar Day (5th July)",
    "Post Didar (6th July)"
] as const


export const VOLUNTEER_FOR_VISIT_MAP = {
    1: "Ja, ich möchte freiwillig helfen",
    0: "Nein, zurzeit nicht verfügbar",
    null: "Keine Auswahl" // default case
} as const

export const VOLUNTEER_FOR_VISIT_MAP_INVERSE = {
    "Ja, ich möchte freiwillig helfen": 1,
    "Nein, zurzeit nicht verfügbar": 0,
    "Nicht spezifiziert": "null",
} as const

export const TrainingSequenceEditMeta: TrainingSequenceEditMetaProps = {
    title: 'Schulungsreihenfolge bearbeiten',
    message: 'Schulungen ziehen, um ihre Reihenfolge zu ändern.',
    cancelButton: 'Abbrechen',
    submitButton: 'Aktualisieren',
    submittingButton: 'Wird aktualisiert...'
}

export const VolunteerOverviewMeta: VolunteerOverviewMetaProps = {
    title: 'Freiwilligen-Übersicht',
    description: 'Überblick über die Demografie der Freiwilligen',
    errorTitle: 'Fehler beim Abrufen der Freiwilligeninformationen',
    loadingText: 'Wird geladen'
}

export const TrainingsOverviewMeta: TrainingsOverviewMetaProps = {
    title: 'Schulungsübersicht',
    description: 'Überblick über Schulungszuweisungen',
    loadingText: 'Wird geladen...',
    errorTitle: 'Fehler beim Laden der Schulungsdaten'
}

export const AllocationsOverviewMeta: AllocationsOverviewMetaProps = {
    title: 'Zuweisungsübersicht',
    description: 'Überblick über die Demografie der Zuweisungen',
    eventsCardTitle: 'Gesamtzahl Veranstaltungen',
    areaCardTitle: 'Gesamtzahl Bereiche',
    shiftCardTitle: 'Gesamtzahl Schichten',
    volunteersCardTitle: 'Gesamtzahl Freiwillige',
    allocationsCardTitle: 'Gesamtzahl Zuweisungen',
    allocationStatusTitle: 'Zuweisungsstatus',
    pendingLabel: 'Ausstehend',
    acceptedLabel: 'Akzeptiert',
    declinedLabel: 'Abgelehnt',
    loadingText: 'Dashboard wird geladen...',
    errorTitle: 'Fehler beim Laden des Dashboards'
}

export const CoreStreamOverviewMeta: CoreStreamOverviewMetaProps = {
    title: 'Kernteam-Streams Übersicht',
    description: 'Überblick über die Kernteam-Stream-Zuweisungen',
    loadingText: 'Wird geladen...',
    errorTitle: 'Fehler beim Laden der Kernteamdaten',
    noDataMessage: 'Keine Kernstream-Daten verfügbar.'
}

export const VolunteerStatsTableOverviewMeta: VolunteerStatsTableOverviewMetaProps = {
    title: 'Freiwilligen-Statistiken',
    description: 'Überblick über die demografischen Statistiken der Freiwilligen',
    loadingText: 'Wird geladen...',
    errorTitle: 'Fehler beim Laden der Statistikdaten.',
    noDataMessage: 'Keine Statistikdaten verfügbar.'
}

export const DidarAcknowledgementOverviewMeta: DidarAcknowledgementOverviewMetaProps = {
    title: 'Übersicht Didar-Bestätigungen',
    description: 'Überblick über Didar-Bestätigungen',
    loadingText: 'Wird geladen...',
    errorTitle: 'Fehler beim Laden der Bestätigungsdaten.',
    noDataMessage: 'Keine Bestätigungsdaten verfügbar.'
}


export const DashboardMeta: DashboardMetaProps = {
    title: 'Dashboard',
    description: 'Überblick über Benutzer, Freiwillige und Zuweisungen',
    eventsCardTitle: 'Gesamtzahl Veranstaltungen',
    areaCardTitle: 'Gesamtzahl Bereiche',
    shiftCardTitle: 'Gesamtzahl Schichten',
    volunteersCardTitle: 'Gesamtzahl Freiwillige',
    allocationsCardTitle: 'Gesamtzahl Zuweisungen',
    allocationStatusTitle: 'Zuweisungsstatus',
    pendingLabel: 'Ausstehend',
    acceptedLabel: 'Akzeptiert',
    declinedLabel: 'Abgelehnt',
    loadingText: 'Dashboard wird geladen...',
    errorTitle: 'Fehler beim Laden des Dashboards'
}


export const MangementAnalyticsMeta: ManagementAnalyticsMetaProps = {
    title: 'Statistiken',
    description: 'Ansichten & Filter',
    errorTitle: 'Fehler beim Abrufen der Dateninformationen',
    loadingText: 'Wird geladen...'
}

export const CHART_COLORS = [
    "#2563eb", // blue
    "#16a34a", // green
    "#f59e0b", // amber
    "#dc2626", // red
    "#7c3aed", // violet
    "#0891b2", // cyan
    "#9333ea", // purple
    "#65a30d", // lime
    "#0f766e", // teal
    "#be123c", // rose
    "#ea580c", // orange
    "#1d4ed8", // indigo
    "#15803d", // dark green
    "#854d0e", // brown/gold
    "#9f1239", // dark rose
    "#0369a1", // sky blue
    "#4d7c0f", // olive
    "#6b21a8", // deep purple
    "#b91c1c", // dark red
    "#0f172a", // slate (near-black)
];




export const CHART_HEIGHT_MAP: Record<MaxChartSize, number> = {
    sm: 220,
    md: 260,
    lg: 300,
    xl: 340,
    '2xl': 380,
    '3xl': 420,
    '4xl': 460,
    '5xl': 520,
    '6xl': 580,
    '7xl': 640,
    '8xl': 720,
    '9xl': 800,
    '10xl': 880,
};

export const CHART_WIDTH_CLASSES: Record<MaxChartSize, string> = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    '8xl': 'max-w-8xl',
    '9xl': 'max-w-9xl',
    '10xl': 'max-w-10xl',
};

export const ANALYTICS_TABS: { key: AnalyticsTab; label: string }[] = [
    { key: "dashboard", label: "Dashboard" },
    { key: "trainings", label: "Schulungsübersicht" },
    { key: "volunteers", label: "Freiwilligen-Demografie" },
    { key: "volunteertable", label: "Freiwilligen-Statistiken" },
    { key: "didar", label: "Didar-Bestätigungen" },
    { key: "iff", label: "Interreligiöse-Familien Demografie" },
    { key: "non-iiuk", label: "Nicht-IIUK Freiwilligen-Demografie" },
    { key: 'duty_acceptance', label: "Aufgabenannahme-Statistiken" },
    { key: 'check-in', label: 'Check-in-Demografie' },
];

export const InternationalRegisterationsMeta: InternationalRegisterationsMetaProps = {
    title: "Internationale Registrierungen",
    description: "Folgende internationale Registrierungen sind eingegangen.",
    errorTitle: "Fehler beim Abrufen internationaler Registrierungen.",
    noDataMessage: "Keine Registrierungen verfügbar.",
    loadingText: "Registrierungsanfrage wird geladen",
    exportButton: "Als CSV exportieren",
    lastSignInColumn: "Letzte Anmeldung",
    neverSignedInText: "Noch nie angemeldet",
}

export const ShiftStatusMap = {
    0: 'Offen',
    1: 'In Überprüfung',
    2: 'Genehmigt',
    3: 'Abgelehnt'
}

export const EmailCampaignsMeta: EmailCampaignsMetaProps = {
    title: 'E-Mail-Kampagnen',
    description: 'Massen-E-Mails an Freiwillige erstellen und verwalten',
    createButton: 'Kampagne erstellen',
    subjectLabel: 'Betreff',
    statusLabel: 'Status',
    recipientsLabel: 'Empfänger',
    progressLabel: 'Fortschritt',
    createdLabel: 'Erstellt',
    actionsLabel: 'Aktionen',
    editButton: 'Bearbeiten',
    deleteButton: 'Löschen',
    viewButton: 'Ansehen',
    statusDraft: 'Entwurf',
    statusTestSent: 'Test gesendet',
    statusPendingApproval: 'Ausstehende Genehmigung',
    statusSending: 'Wird gesendet',
    statusCompleted: 'Abgeschlossen',
    statusFailed: 'Fehlgeschlagen',
    pendingApprovalCountLabel: (count) => `${count} ausstehende Genehmigung`,
    showPendingApprovalOnlyLabel: 'Nur ausstehende Genehmigungen anzeigen',
    showAllCampaignsLabel: 'Alle Kampagnen anzeigen',
    noPendingApprovalCampaignsMessage: 'Derzeit warten keine Kampagnen auf Genehmigung.',
    noCampaignsMessage: 'Keine E-Mail-Kampagnen gefunden. Erstellen Sie Ihre erste Kampagne, um loszulegen.',
    loadingText: 'Kampagnen werden geladen...',
    errorTitle: 'Fehler beim Laden von Kampagnen',
    deleteConfirmTitle: 'Kampagne löschen',
    deleteConfirmMessage: 'Sind Sie sicher, dass Sie diese Kampagne löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    cancelButton: 'Abbrechen',
    confirmDeleteButton: 'Kampagne löschen',
    exportRecipientsButton: 'Empfänger exportieren'
}

export const EmailCampaignFormMeta: EmailCampaignFormMetaProps = {
    createTitle: 'E-Mail-Kampagne erstellen',
    editTitle: 'E-Mail-Kampagne bearbeiten',
    subjectLabel: 'E-Mail-Betreff',
    subjectPlaceholder: 'E-Mail-Betreff eingeben...',
    bodyLabel: 'E-Mail-Inhalt',
    bodyPlaceholder: 'Ihre E-Mail-Nachricht verfassen...',
    saveDraftButton: 'Entwurf speichern',
    cancelButton: 'Abbrechen',
    previewButton: 'Vorschau',
    sendTestButton: 'Test senden',
    sendCampaignButton: 'Kampagne senden',
    submitForApprovalButton: 'Zur Genehmigung einreichen',
    approveCampaignButton: 'Genehmigen und senden',
    denyCampaignButton: 'Ablehnen und wieder öffnen',
    testEmailsLabel: 'Test-E-Mail-Adressen',
    testEmailsPlaceholder: 'email@beispiel.com',
    testEmailsHint: 'Geben Sie bis zu 10 E-Mail-Adressen ein, um Test-E-Mails zu senden',
    addEmailButton: 'E-Mail hinzufügen',
    removeEmailButton: 'Entfernen',
    confirmSendTitle: 'E-Mail-Kampagne senden',
    confirmSendMessage: (count) => `Sie sind dabei, diese E-Mail an ${count} Empfänger zu senden. Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher?`,
    confirmSubmitTitle: 'Kampagne zur Genehmigung einreichen',
    confirmSubmitMessage: (count) => `Diese Kampagne mit ${count} sendbaren Empfänger(n) zur Genehmigung einreichen? Inhalt und Empfänger werden gesperrt.`,
    confirmApproveTitle: 'Kampagne genehmigen und senden',
    confirmApproveMessage: (count) => `Diese Kampagne genehmigen und an ${count} Empfänger senden? Diese Aktion kann nicht rückgängig gemacht werden.`,
    confirmDenyTitle: 'Kampagne ablehnen',
    confirmDenyMessage: 'Diese Kampagne ablehnen und zur Bearbeitung wieder öffnen? Der Ersteller kann Inhalt und Empfänger aktualisieren, bevor sie erneut eingereicht wird.',
    confirmDenyButton: 'Kampagne ablehnen',
    noTestSentWarning: 'Warnung: Sie haben noch keine Test-E-Mails gesendet. Es wird empfohlen, Test-E-Mails zu senden, bevor Sie an alle Freiwilligen senden.',
    confirmButton: 'Senden bestätigen',
    errorSaving: 'Kampagne konnte nicht gespeichert werden',
    errorLoading: 'Kampagne konnte nicht geladen werden',
    successSaved: 'Kampagne erfolgreich gespeichert',
    successTestSent: 'Test-E-Mail(s) erfolgreich gesendet',
    successSent: 'Kampagne wird gesendet',
    successSubmitted: 'Kampagne zur Genehmigung eingereicht',
    successDenied: 'Kampagne abgelehnt und zur Bearbeitung wieder geöffnet',
    contentLockedPendingApproval: 'Diese Kampagne wurde zur Genehmigung eingereicht. Inhalt und Empfänger sind gesperrt, bis ein Genehmiger den Versand startet.',
    // Targeting criteria
    targetingTitle: 'Empfänger nach Gruppe hinzufügen',
    targetingDescription: 'Wählen Sie eine Zielgruppenmethode aus, um eine Gruppe von Empfängern hinzuzufügen',
    allVolunteersLabel: 'Alle Freiwilligen mit eingereichten Profilen',
    targetEventLabel: 'Nach Veranstaltung filtern (optional)',
    targetAreaLabel: 'Nach Bereich filtern (optional)',
    targetShiftLabel: 'Nach Schicht filtern (optional)',
    targetDutyLabel: 'Nach Aufgabentyp filtern (optional)',
    selectEventPlaceholder: 'Alle Veranstaltungen (alle Freiwilligen)',
    selectAreaPlaceholder: 'Alle Bereiche in dieser Veranstaltung',
    selectShiftPlaceholder: 'Alle Schichten in diesem Bereich',
    selectDutyPlaceholder: 'Alle Aufgabentypen',
    loadingEvents: 'Veranstaltungen werden geladen...',
    loadingAreas: 'Bereiche werden geladen...',
    loadingShifts: 'Schichten werden geladen...',
    loadingDuties: 'Aufgaben werden geladen...',
    includeLeadsLabel: 'Auch Leiter einbeziehen:',
    includeEventLeadsLabel: 'Veranstaltungsleiter',
    includeAreaLeadsLabel: 'Bereichsleiter/Stellvertreter',
    includeShiftLeadsLabel: 'Schichtleiter/Stellvertreter',
    // Volunteer types and volunteer filters for "all volunteers" option
    volunteerTypesLabel: 'Freiwilligentypen',
    volunteerTypeIiukUkIreland: 'IIUK registriert (Lokal - Europa)',
    volunteerTypeIiukEurope: 'IIUK registriert (International)',
    volunteerTypeNonIiuk: 'Freiwilligen-Community (Nicht-IIUK)',
    volunteerForVisitLabel: 'Freiwilliger während des Didar',
    volunteerForVisitYes: 'Als Freiwilliger beim Didar (Verfügbarkeit angegeben)',
    volunteerForVisitNo: 'Nein - nicht als Freiwilliger verfügbar',
    volunteerForVisitBoth: 'Beides (alle Antworten)',
    // Recipient management
    recipientManagementTitle: 'Empfänger verwalten',
    recipientManagementDescription: 'Fügen Sie Empfänger einzeln oder gruppenweise hinzu. Duplikate werden automatisch entfernt.',
    recipientSourceHistoryTitle: 'Empfängerquellen-Verlauf',
    recipientSourceHistoryDescription: 'Prüfen Sie vor der Genehmigung, wie die Empfänger hinzugefügt wurden.',
    recipientSourceNoHistory: 'Für diese Kampagne wurde kein Quellenverlauf aufgezeichnet. Sie wurde möglicherweise erstellt, bevor die Nachverfolgung hinzugefügt wurde.',
    recipientSourceAddedLabel: 'Hinzugefügt',
    recipientSourceSelectedLabel: 'Ausgewählt',
    recipientSourceDuplicatesLabel: 'Duplikate übersprungen',
    recipientSourceWithoutEmailLabel: 'Fehlende E-Mail',
    recipientSourceTotalAfterLabel: 'Gesamt nach Änderung',
    recipientSourceAddedByLabel: 'Von',
    recipientSourceShowButton: 'Verlauf anzeigen',
    recipientSourceHideButton: 'Verlauf ausblenden',
    recipientListTitle: 'Empfängerliste',
    noRecipientsMessage: 'Noch keine Empfänger hinzugefügt. Verwenden Sie die Schaltflächen oben, um Empfänger hinzuzufügen.',
    addGroupButton: 'Gruppe hinzufügen',
    addIndividualButton: 'Einzelperson hinzufügen',
    clearAllButton: 'Alle löschen',
    recipientCountLabel: (count) => `${count} Empfänger`,
    removeRecipientButton: 'Entfernen',
    searchVolunteersPlaceholder: 'Freiwillige nach Namen suchen...',
    addSelectedButton: 'Ausgewählte hinzufügen',
    groupAddedMessage: (added, total) => `${added} neue(n) Empfänger hinzugefügt. Gesamt: ${total}`,
    individualAddedMessage: (added, total) => `${added} Empfänger hinzugefügt. Gesamt: ${total}`,
    clearConfirmTitle: 'Alle Empfänger löschen',
    clearConfirmMessage: 'Sind Sie sicher, dass Sie alle Empfänger aus dieser Kampagne entfernen möchten?',
    confirmClearButton: 'Alle löschen',
    // Email suggestions
    emailSuggestionsTitle: 'E-Mail-Adresse festlegen',
    emailSuggestionsDescription: 'Wählen Sie eine E-Mail-Adresse für',
    customEmailLabel: 'Benutzerdefinierte E-Mail eingeben',
    saveButton: 'Speichern',
    noEmailSuggestions: 'Keine Vorschläge verfügbar. Bitte geben Sie eine E-Mail manuell ein.',
    // Retry failed
    retryFailedButton: 'Fehlgeschlagene erneut versuchen',
    retryFailedConfirmTitle: 'Fehlgeschlagene E-Mails erneut versuchen',
    retryFailedConfirmMessage: (count: number) => `Sie sind dabei, das Senden an ${count} fehlgeschlagene Empfänger erneut zu versuchen. Fortfahren?`,
    confirmRetryButton: 'Erneut versuchen',
    successRetry: (count: number) => `Senden von ${count} fehlgeschlagenen E-Mail(s) wird erneut versucht...`
}

export const EmailCampaignPreviewMeta: EmailCampaignPreviewMetaProps = {
    title: 'E-Mail-Vorschau',
    closeButton: 'Schließen',
    backButton: 'Zurück zur Bearbeitung',
    testWarningTitle: 'Hinweis zu Test-E-Mails',
    testWarningMessage: 'Dieses Banner wird nur in Test-E-Mails angezeigt. Es wird nicht in der tatsächlichen Kampagne enthalten sein.'
}

export const ShiftMoveModalMeta: ShiftMoveModalMetaProps = {
    title: "Freiwilligen verschieben",
    submitButton: "Verschieben",
    submittingButton: "Wird verschoben...",
    closeButton: "Abbrechen",
    eventLabel: "Veranstaltung",
    areaLabel: "Bereich",
    shiftLabel: "Schicht",
    eventPlaceHolder: "Veranstaltung auswählen",
    areaPlaceHolder: "Bereich auswählen",
    shiftPlaceHolder: "Schicht auswählen"
}


export const VolunteerUploadDocumentFormMeta: VolunteerUploadDocumentFormMetaProps = {
    title: "Dokument hochladen",
    cancelButton: "Abbrechen",
    submitButton: "Hochladen",
    submittingButton: "Wird hochgeladen...",
    documentTypeLabel: "Dokumenttyp"
}

export const UPLOAD_DOCUMENT_TYPES = ["DBS (Standard)", "DBS (Erweitert)", "Erste Hilfe", "Ärztliches Zeugnis"]

export const AllocationStatusPageMeta: AllocationStatusPageMetaProps = {
    title: 'Verwaltung der Aufgabenannahme',
    description: 'Annahmestatus der Freiwilligenaufgaben einsehen und verwalten, nach verschiedenen Kriterien filtern und Freiwillige bei Bedarf neu zuweisen.',
    backLink: '← Zurück zum Admin-Hub',
    // Status badges
    pendingLabel: 'Ausstehend',
    acceptedLabel: 'Akzeptiert',
    declinedLabel: 'Abgelehnt',
    allLabel: 'Alle',
    // Filter labels
    filtersTitle: 'Filter',
    statusFilterLabel: 'Status',
    eventFilterLabel: 'Veranstaltung',
    areaFilterLabel: 'Bereich',
    shiftFilterLabel: 'Schicht',
    volunteerSearchLabel: 'Freiwilligen suchen',
    volunteerSearchPlaceholder: 'Nach Name, E-Mail oder ID suchen...',
    declineReasonFilterLabel: 'Ablehnungsgrund',
    dateRangeLabel: 'Antwort-Zeitraum',
    dateFromLabel: 'Von',
    dateToLabel: 'Bis',
    offeredAsTknLabel: 'Als TKN angeboten',
    // Volunteer count filters
    volunteerCountsTitle: 'Nach Anzahl der Freiwilligenantworten filtern',
    volunteerCountsEventsLabel: 'Antworten in Veranstaltungen zählen:',
    volunteerCountsEventsAllLabel: 'Alle Veranstaltungen',
    minPendingCountLabel: 'Min Ausstehend',
    maxPendingCountLabel: 'Max Ausstehend',
    minAcceptedCountLabel: 'Min Akzeptiert',
    maxAcceptedCountLabel: 'Max Akzeptiert',
    minDeclinedCountLabel: 'Min Abgelehnt',
    maxDeclinedCountLabel: 'Max Abgelehnt',
    // Filter placeholders
    selectEventPlaceholder: 'Alle Veranstaltungen',
    selectAreaPlaceholder: 'Alle Bereiche',
    selectShiftPlaceholder: 'Alle Schichten',
    selectDeclineReasonPlaceholder: 'Alle Gründe',
    // Actions
    searchButton: 'Suchen',
    clearFiltersButton: 'Filter zurücksetzen',
    exportCsvButton: 'CSV Exportieren',
    exportingButton: 'Wird exportiert...',
    // Table
    tableVolunteerColumn: 'Freiwilliger',
    tableEventColumn: 'Veranstaltung',
    tableAreaColumn: 'Bereich',
    tableShiftColumn: 'Schicht',
    tableStatusColumn: 'Status',
    tableTknColumn: 'TKN',
    tableDeclineReasonColumn: 'Ablehnungsgrund',
    tableResponseDateColumn: 'Antwortdatum',
    tableActionsColumn: 'Aktionen',
    // Bulk actions
    bulkActionsTitle: 'Massenaktionen',
    selectedCountLabel: (count) => `${count} ausgewählt`,
    changeStatusButton: 'Status ändern',
    reAllocateButton: 'Neu zuweisen',
    setToPendingButton: 'Auf Ausstehend setzen',
    setToAcceptedButton: 'Auf Akzeptiert setzen',
    setToDeclinedButton: 'Auf Abgelehnt setzen',
    // Messages
    noResultsMessage: 'Keine Zuweisungen gefunden, die Ihren Kriterien entsprechen.',
    loadingMessage: 'Zuweisungen werden geladen...',
    errorMessage: 'Beim Laden der Zuweisungen ist ein Fehler aufgetreten.',
    bulkUpdateSuccessMessage: (count) => `Erfolgreich ${count} Zuweisung(en) aktualisiert.`,
    bulkUpdateErrorMessage: 'Zuweisungen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
    // Re-allocate modal
    reAllocateTitle: 'Freiwillige(n) neu zuweisen',
    reAllocateDescription: 'Wählen Sie eine neue Schicht aus, um den/die ausgewählten Freiwilligen zuzuweisen. Dies erstellt eine neue Zuweisung, ohne die ursprüngliche zu beeinflussen.',
    reAllocateEventLabel: 'Veranstaltung',
    reAllocateAreaLabel: 'Bereich',
    reAllocateShiftLabel: 'Schicht',
    reAllocateWarning: 'Hinweis: Die ursprüngliche Zuweisung bleibt unverändert. Es wird eine neue Zuweisung mit dem Status „Ausstehend“ erstellt.',
    reAllocateDuplicateWarning: 'Warnung: Einer oder mehrere Freiwillige haben bereits eine Zuweisung für diese Schicht.',
    reAllocateSubmitButton: 'Neue Zuweisung erstellen',
    reAllocatingButton: 'Wird erstellt...',
    reAllocateCancelButton: 'Abbrechen',
    reAllocateSuccessMessage: (count) => `Erfolgreich ${count} neue Zuweisung(en) erstellt.`,
    reAllocateErrorMessage: 'Neue Zuweisungen konnten nicht erstellt werden. Bitte versuchen Sie es erneut.',
    // Pagination
    previousButton: 'Zurück',
    nextButton: 'Weiter',
    pageLabel: 'Seite',
    itemsPerPageLabel: 'Elemente pro Seite',
    totalItemsLabel: (count) => `${count} Gesamtelemente`,
    // Decline reasons (copied from Home for consistency)
    declineReasons: [
        'Die Zeit ist nicht passend (je nach Verfügbarkeit kann eine andere Schicht angeboten werden)',
        'Ich möchte diese spezielle Aufgabe nicht übernehmen (je nach Verfügbarkeit kann eine andere Schicht angeboten werden)',
        'Ich kann mich derzeit nicht festlegen (Ich werde das VRC an dem Tag besuchen)',
        'Ich möchte aus persönlichen Gründen nicht mehr weitermachen'
    ],
    startTimeLabel: 'Startzeit',
    endTimeLabel: 'Endzeit'
}

export const ALLOCATION_STATUS_OPTIONS = ["Accepted", "Declined", "Pending"]

export const CheckInPageMeta: CheckInPageMetaProps = {
    title: 'Freiwilligen Check-in',
    description: 'Scannen Sie die Ausweise von Freiwilligen oder suchen Sie nach dem Namen, um sie für ihre zugewiesenen Aufgaben einzuchecken.',
    backToAdmin: 'Zurück zu Admin',
    // Mode toggle
    scanModeLabel: 'Ausweis scannen',
    searchModeLabel: 'Suchen',
    // Scanner input
    scannerPlaceholder: 'Ausweis scannen oder Barcode eingeben...',
    scannerLabel: 'Ausweis-Scanner',
    scannerHint: 'Positionieren Sie den Ausweis-Barcode vor dem Scanner',
    // Search input
    searchPlaceholder: 'Nach Name, E-Mail oder ID suchen...',
    searchLabel: 'Freiwilligen suchen',
    searchHint: 'Geben Sie mindestens 2 Zeichen zur Suche ein',
    searchButton: 'Suchen',
    searchingText: 'Wird gesucht...',
    searchResultsTitle: 'Suchergebnisse',
    noSearchResultsMessage: 'Keine Freiwilligen gefunden, die Ihrer Suche entsprechen.',
    selectVolunteerButton: 'Auswählen',
    // Event filter
    eventFilterLabel: 'Veranstaltung auswählen',
    selectEventPrompt: 'Bitte wählen Sie eine Veranstaltung aus',
    // Volunteer display
    volunteerNotFoundMessage: 'Freiwilliger nicht gefunden. Bitte versuchen Sie erneut zu scannen.',
    loadingMessage: 'Freiwilliger wird gesucht...',
    errorMessage: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    scanToBeginMessage: 'Scannen Sie einen Freiwilligenausweis, um den Check-in zu beginnen',
    searchToBeginMessage: 'Suchen Sie nach einem Freiwilligen nach Namen, um den Check-in zu beginnen',
    // Volunteer card
    volunteerCardTitle: 'Details des Freiwilligen',
    emailLabel: 'E-Mail',
    phoneLabel: 'Telefon',
    countryLabel: 'Land',
    jamatkhanaLabel: 'Jamatkhana',
    // Allocations
    allocationsTitle: 'Aufgabenzuweisungen',
    noAllocationsMessage: 'Für diesen Freiwilligen wurden keine Aufgabenzuweisungen gefunden.',
    noAllocationsForEventMessage: 'Keine Zuweisungen für die ausgewählte Veranstaltung.',
    eventColumn: 'Veranstaltung',
    areaColumn: 'Bereich',
    shiftColumn: 'Schicht',
    timeColumn: 'Zeit',
    statusColumn: 'Annahme',
    actionColumn: 'Check-in',
    // Check-in status
    checkedInLabel: 'Eingecheckt',
    notCheckedInLabel: 'Nicht eingecheckt',
    checkedInAtLabel: (time) => `Eingecheckt um ${time}`,
    checkedInByLabel: (name) => `von ${name}`,
    // Buttons
    checkInButton: 'Einchecken',
    undoCheckInButton: 'Rückgängig machen',
    checkingInButton: 'Wird eingecheckt...',
    deallocateDutyButton: 'Entfernen',
    deallocatingDutyButton: 'Wird entfernt...',
    scanAnotherButton: 'Nächsten scannen',
    allocateDutyButton: 'Aufgabe zuweisen',
    // Messages
    checkInSuccessMessage: 'Check-in erfolgreich!',
    undoCheckInSuccessMessage: 'Check-in rückgängig gemacht.',
    deallocateDutyConfirmMessage: (dutyName) => `${dutyName} von diesem Freiwilligen entfernen? Dies kann nicht rückgängig gemacht werden.`,
    deallocateDutySuccessMessage: 'Aufgabe erfolgreich entfernt.',
    deallocateDutyErrorMessage: 'Aufgabe konnte nicht entfernt werden. Bitte versuchen Sie es erneut.',
    checkInErrorMessage: 'Check-in fehlgeschlagen. Bitte versuchen Sie es erneut.',
    // Allocation status badges
    pendingStatusLabel: 'Ausstehend',
    acceptedStatusLabel: 'Akzeptiert',
    declinedStatusLabel: 'Abgelehnt',
    // Camera scanning
    cameraScanButton: 'Kamera verwenden',
    cameraScannerTitle: 'Ausweis mit Kamera scannen',
    cameraScannerHint: 'Positionieren Sie den Ausweis-Barcode im Kamerabild',
    cameraPermissionDenied: 'Kamerazugriff wurde verweigert. Bitte erlauben Sie den Kamerazugriff, um diese Funktion zu nutzen.',
    cameraNotSupported: 'Das Scannen mit der Kamera wird auf diesem Gerät nicht unterstützt.',
    closeCameraButton: 'Schließen',
    // Shift View mode
    shiftViewModeLabel: 'Schichtansicht',
    shiftViewAreaLabel: 'Bereich',
    shiftViewShiftLabel: 'Schicht',
    shiftViewSelectAreaPrompt: 'Wählen Sie einen Bereich',
    shiftViewSelectShiftPrompt: 'Wählen Sie eine Schicht',
    shiftViewNoAreasMessage: 'Für die ausgewählten Veranstaltungen wurden keine Bereiche gefunden.',
    shiftViewNoShiftsMessage: 'Für den ausgewählten Bereich wurden keine Schichten gefunden.',
    shiftViewLoadingVolunteers: 'Freiwillige werden geladen...',
    shiftViewNoVolunteersMessage: 'Dieser Schicht sind keine Freiwilligen zugewiesen.',
    shiftViewVolunteerCount: (checked, total) => `${checked}/${total} Eingecheckt`,
    shiftViewNameColumn: 'Name',
    shiftViewPhoneColumn: 'Telefon',
    shiftViewTimeColumn: 'Zeitfenster',
    shiftViewStatusColumn: 'Status',
    shiftViewActionColumn: 'Aktion',
    // Create volunteer
    createVolunteerButton: "Nicht gefunden? Hier erstellen"
}

export const DutyStatusOverviewMeta: DutyStatusOverviewMetaProps = {
    title: "Statistiken zur Aufgabenannahme",
    description: "Die folgende Tabelle ist eine Aufschlüsselung des Aufgabenannahmestatus für veröffentlichte Schichten.",
    errorTitle: "Fehler beim Abrufen der Statistiken.",
    loadingText: "Wird geladen...",
    eventSelectionLabel: "Zu analysierende Veranstaltungen auswählen"
}

export const QuickAllocateModalMeta: QuickAllocateModalMetaProps = {
    title: 'Schnelle Aufgaben-Zuweisung',
    subtitle: (volunteerName) => `Weisen Sie ${volunteerName} eine Aufgabe zu`,
    // Search
    searchPlaceholder: 'Schichten oder Bereiche suchen...',
    // Sort options
    sortLabel: 'Sortieren nach',
    sortByUrgency: 'Dringlichkeit',
    sortByStartTime: 'Startzeit',
    sortByAlphabetical: 'Alphabetisch',
    // Stats labels
    requiredLabel: 'Erforderlich',
    acceptedLabel: 'Akzeptiert',
    checkedInLabel: 'Eingecheckt',
    // Shift display
    noShiftsMessage: 'Für diese Veranstaltung wurden keine verfügbaren Schichten gefunden.',
    loadingShiftsMessage: 'Schichten werden geladen...',
    viewOtherShiftsButton: (count) => `Andere Schichten anzeigen (${count})`,
    hideOtherShiftsButton: 'Andere Schichten ausblenden',
    // Conflict labels
    alreadyAllocatedLabel: 'Bereits zugewiesen',
    timeConflictLabel: 'Zeitkonflikt',
    // Buttons
    allocateButton: 'Zuweisen',
    allocatingButton: 'Wird zugewiesen...',
    cancelButton: 'Abbrechen',
    closeButton: 'Schließen',
    // Messages
    allocationSuccessMessage: 'Aufgabe erfolgreich zugewiesen!',
    allocationErrorMessage: 'Fehler beim Zuweisen der Aufgabe. Bitte versuchen Sie es erneut.'
}

export const LiveOperationsMeta: LiveOperationsMetaProps = {
    title: "Live-Event-Betrieb",
    description: 'Überwachen Sie die Anwesenheit der Freiwilligen, die Schichtabdeckung und kritische Betriebskennzahlen in Echtzeit.',
    errorTitle: 'Fehler',
    areaCheckBoxTitle: 'Bereiche auswählen',
    areaCheckBoxLabel: 'Wählen Sie Bereiche aus den Schichten aus, die angezeigt werden sollen',
    shiftsMeta: { title: 'Verfügbare Schichten', description: 'Die folgenden Schichten benötigen Unterstützung durch Freiwillige' }
}

export const LIVE_OPERATIONS_TABS: { key: LiveStatusTab, header: string }[] = [
    { key: "checkin-stats", header: "Check-ins" },
    { key: "shifts", header: "Dringende Schichten" },
]

export const LoginFormMeta: LoginFormMetaProps = {
    title: 'Nicht-IIUK Anmeldung',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'name@firma.com',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    forgotPassword: 'Passwort vergessen?',
    loginButton: 'Anmelden',
    createAccount: 'Konto erstellen',
    errorLabel: 'Fehler:',
    sending: 'Wird gesendet...',
    resendVerification: 'Bestätigungs-E-Mail erneut senden',
    travelInfo: 'Wenn Sie bereits eine Reise planen und sich freiwillig engagieren möchten, registrieren Sie bitte Ihr Interesse. Freiwilligenarbeit basiert auf persönlichen Vereinbarungen, und alle Reise-, Unterkunfts-, Visa- und damit verbundenen Anforderungen müssen eigenständig organisiert werden.'
}

export const ForgetPasswordMeta: ForgetPasswordMetaProps = {
    back: 'Zurück',
    errorLabel: 'Fehler:',
    successLabel: 'Erfolg!',
    successMessage: 'Bitte überprüfen Sie Ihren E-Mail-Eingang (und Spam-Ordner) auf den Link zum Zurücksetzen des Passworts.',
    title: 'Passwort vergessen',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'sie@beispiel.com',
    sendResetLink: 'Link zum Zurücksetzen senden'
}

export const ResetPasswordMeta: ResetPasswordMetaProps = {
    errorLabel: 'Fehler:',
    successLabel: 'Erfolg!',
    title: 'Passwort zurücksetzen',
    passwordLabel: 'Passwort',
    passwordPlaceholder: 'Neues Passwort',
    confirmPasswordLabel: 'Passwort bestätigen',
    confirmPasswordPlaceholder: 'Neues Passwort bestätigen',
    resetting: 'Wird zurückgesetzt...',
    resetButton: 'Passwort zurücksetzen',
    invalidLinkError: 'Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen.',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein.',
    missingTokenError: 'Token oder E-Mail fehlt. Bitte verwenden Sie den Link aus Ihrer E-Mail.'
}

export const SignupMeta: SignupMetaProps = {
    checkEmailTitle: 'Überprüfen Sie Ihre E-Mail',
    checkEmailMessage: 'Wir haben einen Bestätigungslink an Ihre E-Mail-Adresse gesendet. Bitte klicken Sie auf den Link, um Ihr Konto zu bestätigen.',
    checkEmailHint: 'E-Mail nicht erhalten? Überprüfen Sie Ihren Spam-Ordner. Der Bestätigungslink läuft nach 60 Minuten ab.',
    travelInfo: 'Wenn Sie bereits eine Reise planen und sich freiwillig engagieren möchten, registrieren Sie bitte Ihr Interesse. Freiwilligenarbeit basiert auf persönlichen Vereinbarungen, und alle Reise-, Unterkunfts-, Visa- und damit verbundenen Anforderungen müssen eigenständig organisiert werden.',
    accountInfoTitle: 'Kontoinformationen',
    emailPlaceholder: 'E-Mail-Adresse',
    passwordPlaceholder: 'Passwort',
    rePasswordPlaceholder: 'Passwort erneut eingeben',
    volunteerInfoTitle: 'Freiwilligeninformationen',
    firstNamePlaceholder: 'Vorname',
    lastNamePlaceholder: 'Nachname',
    selectGender: 'Geschlecht wählen',
    male: 'Männlich',
    female: 'Weiblich',
    preferNotToSay: 'Keine Angabe',
    countryCodePlaceholder: 'Landesvorwahl z.B: +49',
    phonePlaceholder: 'Telefonnummer',
    countryPlaceholder: 'Land',
    jamatkhanaPlaceholder: 'Jamatkhana',
    familyOriginLabel: 'Familiäre Herkunft',
    selectOrigin: 'Herkunft wählen',
    additionalDetailsTitle: 'Zusätzliche Angaben',
    ismaili: 'Ismaili',
    interFaithFamily: 'Interreligiöse Familie',
    languagesLabel: 'Sprachen',
    supportNeedsPlaceholder: 'Zusätzliche Unterstützungsbedürfnisse…',
    registerButton: 'Registrieren',
    registering: 'Wird registriert…',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein.',
    faithStatusRequired: 'Bitte wählen Sie entweder Ismaili oder Interreligiöse Familie.',
    invalidDob: 'Bitte geben Sie ein gültiges Geburtsdatum ein.'
}

export const VerifyEmailMeta: VerifyEmailMetaProps = {
    title: 'E-Mail-Bestätigung',
    verifying: 'Ihre E-Mail wird überprüft...',
    successTitle: 'E-Mail erfolgreich bestätigt!',
    successMessage: 'Vielen Dank für Ihre Registrierung als Freiwilliger für den Besuch im Vereinigten Königreich.',
    reviewMessage: 'Ihre Freiwilligenregistrierung wird derzeit überprüft.',
    approvalNotice: 'Sie erhalten eine E-Mail-Benachrichtigung, sobald Ihre Registrierung von unserem Team genehmigt wurde.',
    travelInfo: 'Wenn Sie bereits eine Reise planen und sich freiwillig engagieren möchten, registrieren Sie bitte Ihr Interesse. Freiwilligenarbeit basiert auf persönlichen Vereinbarungen, und alle Reise-, Unterkunfts-, Visa- und damit verbundenen Anforderungen müssen eigenständig organisiert werden.',
    backToLogin: 'Zurück zur Anmeldung',
    backToSignup: 'Zurück zur Registrierung',
    sending: 'Wird gesendet...',
    resendVerification: 'Bestätigungs-E-Mail erneut senden',
    invalidLinkError: 'Ungültiger Bestätigungslink. Bitte überprüfen Sie den Link in Ihrer E-Mail.'
}

export const HouseholdSelectionMeta: HouseholdSelectionMetaProps = {
    errorTitle: 'Fehler',
    returnToLogin: 'Zurück zur Anmeldung',
    title: 'Haushaltsmitglied auswählen',
    description: 'Bitte wählen Sie, als welches Mitglied Ihres Haushalts Sie die Plattform nutzen möchten.',
    youBadge: 'Sie',
    cancel: 'Abbrechen',
    loadError: 'Haushaltsmitglieder konnten nicht geladen werden. Bitte versuchen Sie erneut, sich anzumelden.'
}

export const CheckInLoginFormMeta: CheckInLoginFormMetaProps = {
    errorLabel: 'Fehler:',
    title: 'Anmeldung für Check-ins',
    usernameLabel: 'Benutzername',
    usernamePlaceholder: 'Geben Sie Ihren Benutzernamen ein',
    passwordLabel: 'Passwort',
    passwordPlaceholder: 'Geben Sie Ihr Passwort ein',
    loginButton: 'Anmelden'
}


export const ApprovedCountries = [
    'Austria',
    'Germany',
    'Italy',
    'Poland',
    'Denmark',
    'Finland',
    'Netherlands',
    'Norway',
    'Sweden',
    'Bulgaria',
    'Czech Republic',
    'Estonia',
    'Greece',
    'Hungary',
    'Latvia',
    'Lithuania',
    'Malta',
    'North Macedonia',
    'Romania',
    'Slovakia',
    'Slovenia',
    'North Cyprus',
    'Turkey',
    //'Türkiye',
]


export const EU_JAMAT_KHANA_OPTIONS = [
    'amsterdam',
    'bad salzuflen',
    'berlin',
    'bologna',
    'bosel',
    'bulgaria',
    'cologne',
    'copenhagen',
    'czech',
    'dresden',
    'eindhoven',
    'erfurt',
    'essen',
    'estonia',
    'frankfurt',
    'gothenburg',
    'graz',
    'greece',
    'hamburg',
    'helsinki',
    'hungary',
    'kassel',
    'krakow',
    'latvia',
    'leipzig',
    'linz',
    'lithuania',
    'ljungby',
    'malmo',
    'malta',
    'munich',
    'nicosia',
    'north macedonia',
    'orebro',
    'oslo',
    'romania',
    'rome',
    'rotterdam',
    'rzeszow',
    'slovakia',
    'slovenia',
    'stockholm',
    'stuttgart',
    'szczecin',
    'turkey',
    'umea',
    'vanersborg',
    'vienna',
    'warsaw',
    'wuppertal',
    'zevenaar',
];

export const GuidelineFormModalMeta: GuidelineFormModalMetaProps = {
    title: 'Richtlinie erstellen',
    nameLabel: 'Name',
    namePlaceholder: 'Name...',
    descriptionLabel: 'Beschreibung',
    descriptionPlaceholder: 'Beschreibung...',
    audienceLabel: 'Wer kann diese Richtlinie sehen?',
    audienceAllOption: 'Alle auswählen',
    audienceServiceRecordOption: 'IV-Positionen auswählen',
    addModuleButton: 'Inhalt hinzufügen',
    noModulesMessage: 'Kein Inhalt verfügbar',
    uploadButton: 'Richtlinie speichern',
    uploadingLabel: 'Wird gespeichert...',
    cancelButton: 'Abbrechen',
    submitButton: 'Absenden',
    submittingButton: 'Wird gesendet...'
}

export const AdminGuidelinesMeta: AdminGuidelinesMetaProps = {
    title: 'Richtlinien',
    description: 'Referenzrichtlinien für Freiwillige verwalten',
    errorTitle: 'Fehler',
    noGuidelinesMessage: 'Noch keine Richtlinien',
    loadingText: 'Wird geladen...'
}

export const VolunteerGuidelinesMeta: VolunteerGuidelinesMetaProps = {
    title: 'Richtlinien',
    errorTitle: 'Fehler',
    noGuidelinesMessage: 'Keine Richtlinien verfügbar',
    documentsLabel: 'Dokument(e)'
}

export const GuidelineDetailsMeta: GuidelineDetailsMetaProps = {
    backButtonLabel: 'Zurück zu den Richtlinien',
    errorTitle: 'Fehler',
    notFoundMessage: 'Richtlinie nicht gefunden'
}

export const DirectorVolunteerMeta: DirectorVolunteerMetaProps = {
    title: "Freiwillige deiner Jamat Khana",
    description: "Freiwillige deiner Jamat Khana anzeigen"
}


